export default {
  // 运价查询
  rateQuery: {
    title: '运价查询',
    description: '查询整箱、拼箱、空运、港前和尾程运价信息',
    filterTitle: '筛选条件',
    destination: {
      label: '目的地',
      placeholder: '请选择目的地'
    },
    totalCount: '共 {count} 条',
    priceDisplay: {
      mode: '价格显示模式',
      numeric: '单一币种(加总)',
      currencyStr: '多币种详情'
    },
    fclCard: {
      carrier: '船公司',
      routeInfo: '航线信息',
      remarks: '备注',
      validPeriod: '有效期',
      operation: '操作',
      dateTo: '至',
      detail: '详情',
      schedule: '船期',
      linkConsignment: '关联委托',
      cargoType: '货物类型',
      supplier: '供应商：',
      source: {
        inquiry: '询价',
        bidding: '招标',
        manual: '手工',
        system: '系统',
        unknown: '未知来源'
      },
      status: {
        normal: '有效',
        expired: '已过期',
        disabled: '已停用',
        unknown: '未知状态'
      }
    },

    rail: {
      filters: {
        pol: '起运地',
        pod: '目的地',
        railCompany: '铁路公司'
      },
      placeholders: {
        pol: '请选择起运地',
        pod: '请选择目的地',
        railCompany: '请选择铁路公司',
        select: '请选择',
        input: '请输入',
        startDate: '开始日期',
        endDate: '结束日期'
      },
      actions: {
        search: '查询',
        reset: '重置',
        combinationQuery: '组合方案查询',
        viewDetail: '查看详情'
      },
      columns: {
        priceNo: '运价编号',
        direction: '方向',
        pol: '起运地',
        pod: '目的地',
        railCompany: '铁路公司',
        routeType: '路线类型',
        containerOwner: '箱属',
        cargoType: '货物类型',
        transportMode: '服务类型',
        transportTerms: '运输条款',
        exitPort: '出境口岸',
        directTransit: '直达/中转',
        countryOfDeparture: '起运国',
        cityOfDeparture: '起运城市',
        countryOfDestination: '目的国',
        cityOfDestination: '目的城市',
        transitStations: '中转站点',
        supplier: '供应商',
        companyIds: '所属公司',
        price: '价格信息',
        transitDays: '在途天数',
        validPeriod: '有效期',
        startDate: '开始日期',
        endDate: '结束日期',
        status: '状态',
        actions: '操作'
      },
      messages: {
        exportFilename: '铁路运价导出',
        loadFailed: '加载铁路运价数据失败',
        viewDetailFailed: '查看详情失败',
        exportNotImplemented: '导出功能待开发',
        basePrice: '基价',
        totalRows: '共 {count} 行',
        minPrice: '最低 {price}',
        placeholder: '--',
        detailTitle: '铁路运价详情',
        notFound: '未找到运价信息',
        surchargeTitle: '附加费',
        byContainerType: '按箱型',
        missingId: '缺少运价ID',
        loadDetailFailed: '加载运价详情失败',
        confirmExportSelected: '将导出已勾选的 {count} 条铁路运价，导出任务将在后台执行，完成后可在任务中心下载。',
        dayUnit: '{count}天',
        outbound: '去程',
        inbound: '回程',
        railwayBox: '铁路箱',
        inlandPortBox: '陆港箱',
        crBox: '中铁箱',
        nonCrBox: '非中铁箱',
        middleLine: '中线',
        northLine: '北线',
        southLine: '南线',
        southeastAsia: '东南亚',
        centralAsia: '中亚',
        expired: '已失效',
        disabled: '已禁用'
      },
      combination: {
        title: '组合方案查询',
        back: '返回',
        steps: {
          conditions: '填写查询条件',
          conditionsDesc: '配置查询参数',
          rate: '选择匹配运价',
          rateDesc: '选择合适方案'
        },
        sections: {
          basic: '基本信息',
          loadingAddress: '装箱门点（可选）',
          deliveryAddress: '尾程送货地址（可选）',
          rate: '选择匹配运价'
        },
        fields: {
          pol: '起运港',
          pod: '目的港',
          route: '航线',
          carrier: '船公司',
          transportType: '运输类型',
          provinceCityDistrict: '省 / 市 / 区',
          detailAddress: '详细地址',
          addressType: '地址类型',
          countryPostcode: '国家 + 邮编',
          stateCityRegion: '州 / 市 / 区域',
          warehouseCode: '仓库代码'
        },
        placeholders: {
          pol: '请选择起运港',
          pod: '请选择目的港',
          route: '请选择航线',
          carrier: '请选择船公司',
          province: '请选择省份',
          city: '请选择城市',
          district: '请选择区县',
          detailAddress: '请输入详细地址',
          country: '请选择国家',
          postcode: '请输入邮编',
          state: '请选择州',
          region: '请选择区域',
          amazonWarehouse: '请选择亚马逊仓库',
          ecangWarehouse: '请选择易仓仓库'
        },
        options: {
          notSpecified: '不指定',
          thirdPartyAddress: '第三方地址',
          amazonWarehouse: '亚马逊仓库',
          ecangWarehouse: '易仓'
        },
        actions: {
          previous: '上一步',
          next: '下一步',
          query: '查询方案'
        },
        messages: {
          apiPending: '铁路组合方案查询接口待对接'
        },
        empty: '暂无铁路组合方案数据'
      }
    },

    // 标签页
    tabs: {
      fcl: '整箱运价',
      lcl: '拼箱运价',
      air: '空运运价',
      precarriage: '港前运价',
      oncarriage: '尾程运价',
      express: '快递运价',
      rail: '铁路运价'
    },

    // 筛选条件
    filters: {
      carrier: '船公司',
      carrierPlaceholder: '请选择船公司',
      validPeriod: '有效期',
      routeName: '航线名称',
      routeNamePlaceholder: '请选择航线名称',
      departurePort: '起运港',
      departurePortPlaceholder: '请选择起运港',
      dischargePort: '卸货港',
      dischargePortPlaceholder: '请选择卸货港',
      // Extension filter conditions
      priceNo: '运价号',
      priceNoPlaceholder: '请输入运价号',
      rateType: '运价类型',
      rateTypePlaceholder: '请选择运价类型',
      status: '状态',
      statusPlaceholder: '请选择运价状态',
      cargoType: '货物类型',
      cargoTypePlaceholder: '请选择货物类型',
      routeCategory: '航线分类',
      routeCategoryPlaceholder: '请选择航线分类',
      validStartDate: '开始日期',
      validEndDate: '结束日期',
      loadingAddress: '装箱地址',
      deliveryAddress: '送货地址',
      detailAddressPlaceholder: '请输入省/市/区/详细地址',
      originWharf: '起运码头',
      destinationWharf: '目的码头',
      wharfPlaceholder: '请输入码头名称（可选）',
      supplier: '供应商',
      contractNo: '约号',
      contractNoPlaceholder: '请选择约号',
      vesselName: '船名',
      vesselNamePlaceholder: '请输入船名',
      voyageNo: '航次',
      voyageNoPlaceholder: '请输入航次',
      weekdays: '船期',
      weekdaysPlaceholder: '请选择船期',
      transitType: '中转类型',
      transitTypePlaceholder: '请选择中转类型',
      spaceStatus: '舱位状态',
      spaceStatusPlaceholder: '请选择舱位状态',
      transitPort: '中转港',
      transitPortPlaceholder: '请选择中转港',
      priceTrend: '价格趋势',
      priceTrendPlaceholder: '请选择价格趋势',
      routeCode: '航线代码',
      routeCodePlaceholder: '请输入航线代码',
      voyageDays: '航程天数',
      voyageDaysPlaceholder: '请输入航程天数',
      detentionFreeDays: '免用箱期',
      detentionFreeDaysPlaceholder: '请输入免用箱期（天）',
      demurrageFreeDays: '免堆存期',
      demurrageFreeDaysPlaceholder: '请输入免堆存期（天）',
      nac: 'NAC',
      nacPlaceholder: '请选择NAC',
      remarks: '备注',
      remarksPlaceholder: '请输入备注',
      createdBy: '创建人',
      createdByPlaceholder: '请输入创建人',
      modifiedBy: '修改人',
      modifiedByPlaceholder: '请输入修改人',
      // Time filters
      beginDate: '生效日期',
      beginDatePlaceholder: '请选择生效日期范围',
      endDate: '失效日期',
      endDatePlaceholder: '请选择失效日期范围',
      etdRange: 'ETD范围',
      etdRangePlaceholder: '请选择ETD范围',
      etaRange: 'ETA范围',
      etaRangePlaceholder: '请选择ETA范围',
      createTime: '创建时间',
      createTimePlaceholder: '请选择创建时间范围',
      updateTime: '更新时间',
      updateTimePlaceholder: '请选择修改时间范围',
      // Exact matches for fallback search
      selectEffectiveDate: '请选择生效日期',
      selectExpiryDate: '请选择失效日期',
      enterWharf: '请输入码头',
      selectSupplier: '请选择供应商',
      selectPortType: '请选择港口类型',
      selectDirectTransitExact: '请选择直达/中转'
    },

    // 选项
    options: {
      inquiry: '电询',
      direct: '直达',
      transit: '中转',
      // 状态选项
      enabled: '启用',
      disabled: '禁用',
      draft: '草稿',
      published: '发布',
      invalid: '失效',
      offline: '下架',
      // 运价类型选项
      contract: '合约价',
      spot: 'SPOT电商',
      // 货物类型选项
      general: '普货',
      dangerous: '危险品',
      frozen: '冷冻货',
      special: '特殊货',
      steelCoil: '钢卷',
      liquid: '液体货',
      chemical: '化工品',
      textile: '纺织品',
      // 舱位状态选项
      smooth: '畅接',
      singleApply: '单票申请',
      overbooked: '爆舱',
      notAccepting: '不接',
      // 价格趋势选项
      rising: '上涨',
      falling: '下跌',
      stable: '平稳',
      // 运价查询特有选项
      queryStatus: {
        pending: '查询中',
        completed: '查询完成',
        failed: '查询失败',
        cancelled: '查询取消'
      },
      // 组合查询方案状态
      solutionStatus: {
        available: '可用',
        unavailable: '不可用',
        pending: '待确认',
        confirmed: '已确认',
        rejected: '已拒绝'
      },
      // 匹配度等级
      matchLevel: {
        excellent: '优秀',
        good: '良好',
        fair: '一般',
        poor: '较差'
      },
      // 风险等级
      riskLevel: {
        low: '低风险',
        medium: '中等风险',
        high: '高风险'
      },
      // 可行性等级
      feasibility: {
        highlyFeasible: '高度可行',
        feasible: '可行',
        partiallyFeasible: '部分可行',
        notFeasible: '不可行'
      },
      // 支线类型
      branchLines: {
        zhapu: '乍浦支线',
        wenzhou: '温州支线',
        haining: '海宁支线',
        yangzi: '扬子支线',
        mawei: '马尾支线',
        yiwu: '义乌海铁',
        huzhou: '湖州海铁',
        jiujiang: '九江海铁'
      }
    },

    // 航线
    routes: {
      asiaIntra: '亚洲区内航线',
      feSea: '远东-东南亚航线',
      feMe: '远东-中东航线',
      // 主要航线
      transPacific: '太平洋航线',
      transAtlantic: '大西洋航线',
      europeAsia: '欧亚航线',
      mediterranean: '地中海航线',
      redSea: '红海航线',
      indianOcean: '印度洋航线',
      // 区域航线
      northAsia: '北亚航线',
      southeastAsia: '东南亚航线',
      southAsia: '南亚航线',
      westAsia: '西亚航线',
      africa: '非洲航线',
      australia: '澳洲航线',
      // 特殊航线
      arctic: '北极航线',
      suez: '苏伊士运河航线',
      panama: '巴拿马运河航线'
    },

    // 港口
    ports: {
      shanghai: '上海',
      ningbo: '宁波',
      qingdao: '青岛',
      // 中国主要港口
      xiamen: '厦门',
      guangzhou: '广州',
      shenzhen: '深圳',
      tianjin: '天津',
      dalian: '大连',
      yantai: '烟台',
      lianyungang: '连云港',
      // 亚洲主要港口
      busan: '釜山',
      tokyo: '东京',
      yokohama: '横滨',
      singapore: '新加坡',
      portKlang: '巴生港',
      laemChabang: '林查班',
      // 欧洲主要港口
      rotterdam: '鹿特丹',
      hamburg: '汉堡',
      antwerp: '安特卫普',
      leHavre: '勒阿弗尔',
      // 美洲主要港口
      losAngeles: '洛杉矶',
      longBeach: '长滩',
      newYork: '纽约',
      savannah: '萨凡纳'
    },

    // 船公司
    carriers: {
      msc: '地中海航运',
      maersk: '马士基航运',
      cmaCgm: '达飞轮船',
      cosco: '中远海运',
      evergreen: '长荣海运',
      yangMing: '阳明海运',
      hmm: '现代商船',
      one: '海洋网联',
      zim: '以星航运',
      hpl: '赫伯罗特',
      hplQq: '赫伯罗特 QQ',
      hplSpot: '赫伯罗特 SPOT',
      oocl: '东方海外',
      pil: '太平船务',
      csc: '中远集运',
      cz: '南方航空',
      mu: '东方航空',
      ca: '国际航空',
      ci: '中华航空'
    },

    // 币种
    currencies: {
      usd: '美元',
      cny: '人民币',
      eur: '欧元',
      jpy: '日元',
      gbp: '英镑',
      hkd: '港币',
      sgd: '新加坡元',
      krw: '韩元',
      thb: '泰铢',
      myr: '马来西亚林吉特',
      idr: '印尼盾',
      php: '菲律宾比索'
    },

    // 计费单位
    billingUnits: {
      teu: 'TEU',
      cbm: 'CBM',
      kgs: 'KGS',
      pcs: 'PCS',
      set: 'SET',
      pallet: '托盘',
      container: '集装箱',
      ton: '吨',
      meter: '米',
      square: '平方米'
    },

    // 费用项目
    chargeItems: {
      // 海运费用
      oceanFreight: '海运费',
      thc: '码头操作费',
      doc: '文件费',
      seal: '铅封费',
      // 附加费用
      baf: '燃油附加费',
      caf: '货币调整费',
      ebs: '紧急燃油附加费',
      ccs: '集装箱不平衡费',
      // 港口费用
      portCharges: '港口费用',
      terminalHandling: '码头处理费',
      wharfage: '码头费',
      // 其他费用
      customsClearance: '清关费',
      inspection: '检验费',
      insurance: '保险费',
      storage: '仓储费'
    },

    // 集装箱类型
    containerTypes: {
      // 标准箱
      gp20: '20GP',
      gp40: '40GP',
      hc40: '40HC',
      hc45: '45HC',
      // 特殊箱
      rf20: '20RF',
      rf40: '40RF',
      tk20: '20TK',
      tk40: '40TK',
      ot20: '20OT',
      ot40: '40OT',
      fr20: '20FR',
      fr40: '40FR',
      // 其他箱型
      nor20: '20NOR',
      nor40: '40NOR',
      flat20: '20FLAT',
      flat40: '40FLAT'
    },

    // 星期
    weekdays: {
      monday: '周一',
      tuesday: '周二',
      wednesday: '周三',
      thursday: '周四',
      friday: '周五',
      saturday: '周六',
      sunday: '周日',
      // 简写
      mon: '一',
      tue: '二',
      wed: '三',
      thu: '四',
      fri: '五',
      sat: '六',
      sun: '日'
    },

    // 分页
    pagination: {
      total: '共 {total} 条',
      pageSize: '每页 {pageSize} 条',
      current: '第 {current} 页',
      goto: '跳至',
      page: '页',
      of: '共',
      items: '条记录',
      showTotal: '显示第 {start} 到 {end} 条，共 {total} 条',
      showSizeChanger: '显示条数',
      showQuickJumper: '快速跳转',
      showLessItems: '显示较少页码',
      showMoreItems: '显示更多页码'
    },

    // 导出
    export: {
      title: '导出数据',
      filename: '运价查询结果',
      format: '导出格式',
      excel: 'Excel文件',
      csv: 'CSV文件',
      pdf: 'PDF文件',
      allColumns: '所有列',
      selectedColumns: '选中列',
      customColumns: '自定义列',
      download: '下载',
      cancel: '取消',
      processing: '正在导出...',
      success: '导出成功',
      failed: '导出失败'
    },

    // 表格操作
    table: {
      // 工具栏
      toolbar: {
        refresh: '刷新',
        density: '密度',
        columnSetting: '列设置',
        fullScreen: '全屏',
        exitFullScreen: '退出全屏',
        reload: '重新加载',
        export: '导出',
        import: '导入',
        print: '打印'
      },
      // 行操作
      rowActions: {
        view: '查看',
        edit: '编辑',
        delete: '删除',
        copy: '复制',
        enable: '启用',
        disable: '禁用',
        more: '更多'
      },
      // 批量操作
      batchActions: {
        selectAll: '全选',
        unselectAll: '取消全选',
        selectedCount: '已选择 {count} 项',
        batchDelete: '批量删除',
        batchEnable: '批量启用',
        batchDisable: '批量禁用',
        batchExport: '批量导出'
      }
    },

    // 搜索和筛选
    search: {
      // 搜索框
      searchBox: {
        placeholder: '请输入关键词搜索',
        searchButton: '搜索',
        clearButton: '清空',
        advancedSearch: '高级搜索',
        simpleSearch: '简单搜索'
      },
      // 高级筛选
      advancedFilter: {
        title: '高级筛选',
        expand: '展开',
        collapse: '收起',
        addCondition: '添加条件',
        removeCondition: '删除条件',
        clearAll: '清空所有',
        apply: '应用',
        reset: '重置',
        saveAsDefault: '保存为默认',
        loadDefault: '加载默认'
      },
      // 筛选条件
      filterConditions: {
        and: '且',
        or: '或',
        equals: '等于',
        notEquals: '不等于',
        contains: '包含',
        notContains: '不包含',
        startsWith: '开始于',
        endsWith: '结束于',
        greaterThan: '大于',
        greaterThanOrEqual: '大于等于',
        lessThan: '小于',
        lessThanOrEqual: '小于等于',
        between: '介于',
        in: '在...之中',
        notIn: '不在...之中',
        isNull: '为空',
        isNotNull: '不为空'
      }
    },

    // 状态和提示
    status: {
      // 加载状态
      loading: '加载中...',
      loaded: '加载完成',
      loadingFailed: '加载失败',
      // 操作状态
      processing: '处理中...',
      success: '操作成功',
      failed: '操作失败',
      cancelled: '操作已取消',
      // 数据状态
      noData: '暂无数据',
      emptyData: '数据为空',
      partialData: '部分数据加载失败',
      // 网络状态
      networkError: '网络错误',
      serverError: '服务器错误',
      timeout: '请求超时',
      unauthorized: '未授权访问',
      forbidden: '禁止访问',
      notFound: '资源不存在'
    },

    // 提示信息
    tips: {
      // 操作提示
      clickToView: '点击查看详情',
      clickToEdit: '点击编辑',
      clickToDelete: '点击删除',
      clickToEnable: '点击启用',
      clickToDisable: '点击禁用',
      // 选择提示
      selectItems: '请选择要操作的项',
      selectAtLeastOne: '请至少选择一项',
      selectMaxItems: '最多只能选择 {max} 项',
      // 确认提示
      confirmOperation: '确认执行此操作？',
      operationIrreversible: '此操作不可逆',
      dataWillBeLost: '数据将会丢失',
      // 帮助提示
      help: '帮助',
      moreInfo: '更多信息',
      contactSupport: '联系支持'
    },

    // 日期和时间
    dateTime: {
      // 日期格式
      formats: {
        date: 'YYYY-MM-DD',
        dateTime: 'YYYY-MM-DD HH:mm:ss',
        time: 'HH:mm:ss',
        month: 'YYYY-MM',
        year: 'YYYY'
      },
      // 日期标签
      labels: {
        today: '今天',
        yesterday: '昨天',
        tomorrow: '明天',
        thisWeek: '本周',
        lastWeek: '上周',
        nextWeek: '下周',
        thisMonth: '本月',
        lastMonth: '上月',
        nextMonth: '下月',
        thisYear: '今年',
        lastYear: '去年',
        nextYear: '明年'
      },
      // 时间标签
      timeLabels: {
        now: '现在',
        morning: '上午',
        afternoon: '下午',
        evening: '晚上',
        night: '深夜'
      },
      // 相对时间
      relative: {
        justNow: '刚刚',
        minutesAgo: '{minutes} 分钟前',
        hoursAgo: '{hours} 小时前',
        daysAgo: '{days} 天前',
        weeksAgo: '{weeks} 周前',
        monthsAgo: '{months} 个月前',
        yearsAgo: '{years} 年前'
      },
      // 日期范围
      range: {
        validFrom: '{date} 起',
        validUntil: '至 {date}'
      }
    },

    // 错误和异常
    errors: {
      // 通用错误
      general: {
        unknown: '未知错误',
        systemError: '系统错误',
        networkError: '网络错误',
        serverError: '服务器错误',
        clientError: '客户端错误',
        timeout: '请求超时',
        connectionFailed: '连接失败'
      },
      // 数据错误
      data: {
        invalidData: '数据无效',
        dataNotFound: '数据未找到',
        dataCorrupted: '数据损坏',
        dataIncomplete: '数据不完整',
        dataMismatch: '数据不匹配',
        dataExpired: '数据已过期'
      },
      // 权限错误
      permission: {
        unauthorized: '未授权',
        forbidden: '禁止访问',
        insufficientPrivileges: '权限不足',
        accessDenied: '访问被拒绝',
        loginRequired: '需要登录',
        sessionExpired: '会话已过期'
      },
      // 验证错误
      validation: {
        required: '此字段为必填项',
        invalidFormat: '格式无效',
        tooLong: '内容过长',
        tooShort: '内容过短',
        invalidValue: '值无效',
        duplicateValue: '值重复'
      },
      // 消息提示
      messages: {
        exportTaskFailed: '导出任务触发失败，请稍后重试',
        selectRecordsFirst: '请先选择要导出的记录',
        noDataToExport: '没有可导出的数据',
        exportFailed: '{type} 导出失败，请稍后重试'
      }
    },

    // 成功和确认
    success: {
      // 操作成功
      operations: {
        create: '创建成功',
        update: '更新成功',
        delete: '删除成功',
        save: '保存成功',
        submit: '提交成功',
        approve: '审批成功',
        reject: '拒绝成功',
        enable: '启用成功',
        disable: '禁用成功',
        import: '导入成功',
        export: '导出成功'
      },
      // 状态变更
      status: {
        activated: '已激活',
        deactivated: '已停用',
        published: '已发布',
        unpublished: '已取消发布',
        archived: '已归档',
        restored: '已恢复',
        locked: '已锁定',
        unlocked: '已解锁'
      },
      // 消息提示
      messages: {
        operationCompleted: '操作完成',
        dataSaved: '数据已保存',
        changesApplied: '更改已应用',
        settingsUpdated: '设置已更新',
        configurationSaved: '配置已保存',
        exportTaskTriggered: '导出任务已成功触发，请稍后查看导出结果',
        exportSuccess: '{type} 导出成功，共导出 {count} 条记录'
      }
    },

    // 确认对话框
    confirm: {
      // 通用确认
      general: {
        title: '确认操作',
        message: '确定要执行此操作吗？',
        okText: '确定',
        cancelText: '取消',
        yesText: '是',
        noText: '否'
      },
      // 删除确认
      delete: {
        title: '确认删除',
        message: '确定要删除这条记录吗？',
        batchMessage: '确定要删除选中的 {count} 条记录吗？',
        warning: '删除后不可恢复',
        permanent: '此操作不可逆'
      },
      // 状态变更确认
      status: {
        enable: {
          title: '确认启用',
          message: '确定要启用这条记录吗？',
          batchMessage: '确定要启用选中的 {count} 条记录吗？'
        },
        disable: {
          title: '确认禁用',
          message: '确定要禁用这条记录吗？',
          batchMessage: '确定要禁用选中的 {count} 条记录吗？'
        }
      },
      // 保存确认
      save: {
        title: '确认保存',
        message: '确定要保存更改吗？',
        unsavedChanges: '有未保存的更改，确定要离开吗？',
        discardChanges: '确定要放弃更改吗？'
      }
    },

    // 帮助和文档
    help: {
      // 帮助菜单
      menu: {
        help: '帮助',
        userGuide: '用户指南',
        faq: '常见问题',
        contactSupport: '联系支持',
        about: '关于系统',
        feedback: '意见反馈'
      },
      // 用户指南
      userGuide: {
        title: '用户指南',
        gettingStarted: '快速开始',
        basicOperations: '基本操作',
        advancedFeatures: '高级功能',
        troubleshooting: '故障排除',
        shortcuts: '快捷键'
      },
      // 常见问题
      faq: {
        title: '常见问题',
        search: '搜索问题',
        categories: '问题分类',
        popular: '热门问题',
        recent: '最新问题'
      },
      // 联系支持
      support: {
        title: '联系支持',
        email: '邮箱支持',
        phone: '电话支持',
        onlineChat: '在线客服',
        ticket: '工单系统',
        responseTime: '响应时间'
      }
    },

    // 系统设置
    settings: {
      // 基本设置
      basic: {
        title: '基本设置',
        language: '语言设置',
        timezone: '时区设置',
        dateFormat: '日期格式',
        timeFormat: '时间格式',
        currency: '货币设置',
        units: '单位设置'
      },
      // 显示设置
      display: {
        title: '显示设置',
        theme: '主题设置',
        fontSize: '字体大小',
        colorScheme: '配色方案',
        layout: '布局设置',
        density: '密度设置'
      },
      // 通知设置
      notification: {
        title: '通知设置',
        email: '邮件通知',
        sms: '短信通知',
        push: '推送通知',
        sound: '声音提醒',
        frequency: '通知频率'
      },
      // 安全设置
      security: {
        title: '安全设置',
        password: '密码设置',
        twoFactor: '双因素认证',
        session: '会话管理',
        permissions: '权限管理',
        audit: '审计日志'
      }
    },

    // 用户和权限
    user: {
      // 用户管理
      management: {
        title: '用户管理',
        userList: '用户列表',
        addUser: '添加用户',
        editUser: '编辑用户',
        deleteUser: '删除用户',
        userProfile: '用户资料',
        changePassword: '修改密码'
      },
      // 角色管理
      roles: {
        title: '角色管理',
        roleList: '角色列表',
        addRole: '添加角色',
        editRole: '编辑角色',
        deleteRole: '删除角色',
        assignRole: '分配角色',
        permissions: '权限设置'
      },
      // 权限管理
      permissions: {
        title: '权限管理',
        permissionList: '权限列表',
        addPermission: '添加权限',
        editPermission: '编辑权限',
        deletePermission: '删除权限',
        assignPermission: '分配权限',
        permissionGroups: '权限组'
      },
      // 用户状态
      status: {
        active: '活跃',
        inactive: '非活跃',
        locked: '已锁定',
        suspended: '已暂停',
        pending: '待审核',
        expired: '已过期'
      }
    },

    // 报表和统计
    reports: {
      // 报表管理
      management: {
        title: '报表管理',
        reportList: '报表列表',
        createReport: '创建报表',
        editReport: '编辑报表',
        deleteReport: '删除报表',
        scheduleReport: '定时报表',
        reportTemplates: '报表模板'
      },
      // 统计图表
      charts: {
        title: '统计图表',
        lineChart: '折线图',
        barChart: '柱状图',
        pieChart: '饼图',
        areaChart: '面积图',
        scatterChart: '散点图',
        radarChart: '雷达图'
      },
      // 数据维度
      dimensions: {
        title: '数据维度',
        time: '时间维度',
        region: '地区维度',
        product: '产品维度',
        customer: '客户维度',
        channel: '渠道维度',
        category: '分类维度'
      },
      // 报表类型
      types: {
        title: '报表类型',
        summary: '汇总报表',
        detail: '明细报表',
        comparison: '对比报表',
        trend: '趋势报表',
        distribution: '分布报表',
        custom: '自定义报表'
      }
    },

    // 导入和导出
    importExport: {
      // 导入功能
      import: {
        title: '数据导入',
        selectFile: '选择文件',
        dragDrop: '拖拽文件到此处',
        supportedFormats: '支持格式',
        maxFileSize: '最大文件大小',
        templateDownload: '下载模板',
        importPreview: '导入预览',
        importProgress: '导入进度',
        importResult: '导入结果'
      },
      // 导出功能
      export: {
        title: '数据导出',
        exportFormat: '导出格式',
        exportRange: '导出范围',
        exportColumns: '导出列',
        exportFilters: '导出筛选',
        exportSchedule: '导出计划',
        exportHistory: '导出历史',
        downloadFile: '下载文件'
      },
      // 文件格式
      formats: {
        excel: 'Excel文件',
        csv: 'CSV文件',
        pdf: 'PDF文件',
        json: 'JSON文件',
        xml: 'XML文件',
        txt: '文本文件'
      },
      // 导入状态
      status: {
        pending: '等待中',
        processing: '处理中',
        completed: '已完成',
        failed: '失败',
        cancelled: '已取消',
        partial: '部分成功'
      }
    },

    // 表格列
    columns: {
      carrier: '船公司',
      dischargePort: '卸货港',
      transitType: '直达/中转',
      transit: '航程',
      routeCode: '航线代码',
      vesselName: '船名',
      voyageNo: '航次',
      spaceStatus: '舱位状态',
      remark: '备注',
      weight: '重量(KGS)',
      volume: '体积(CBM)',
      // 通用列
      actions: '操作',
      status: '状态',
      createTime: '创建时间',
      updateTime: '更新时间',
      createBy: '创建人',
      updateBy: '更新人',
      // 运价相关列
      priceNo: '运价号',
      rateType: '运价类型',
      pol: '起运港',
      pod: '卸货港',
      pot: '中转港',
      contractNo: '约号',
      validPeriod: '有效期',
      etd: 'ETD',
      eta: 'ETA',
      // 费用相关列
      freight: '运费',
      currency: '币种',
      chargeItem: '费用项目',
      billingUnit: '计费单位',
      // 运价查询特有列
      queryTime: '查询时间',
      queryUser: '查询用户',
      queryResult: '查询结果',
      matchScore: '匹配度',
      totalPrice: '总价格',
      priceBreakdown: '价格明细',
      // 组合查询相关列
      solutionType: '方案类型',
      solutionName: '方案名称',
      solutionDescription: '方案描述',
      feasibility: '可行性',
      estimatedTime: '预计时间',
      riskLevel: '风险等级',
      // 整箱运价详情页相关列
      freeContainerDays: '免用箱',
      demurrageFreeDays: '免堆存',
      overweightRemarks: '超重说明',
      receivingInstructions: '接货特殊说明'
    },

    // FCL筛选字段国际化
    filterFields: {
      // 标签
      labels: {
        routeCode: '运价号',
        rateType: '运价类型',
        departurePort: '起运港',
        dischargePort: '卸货港',
        directTransit: '直达/中转',
        transitPort: '中转港',
        transitType: '中转类型',
        shipCompany: '船公司',
        contractNo: '约号',
        spaceStatus: '舱位状态',
        priceStatus: '价格趋势',
        cargoType: '货物类型',
        vesselSchedule: '船期',
        voyage: '航程',
        freeStorageDays: '免用箱',
        nac: 'NAC',
        validPeriod: '有效期',
        etd: 'ETD',
        eta: 'ETA',
        vesselName: '船名',
        voyageNo: '航次',
        cutoffDate: '截关日',
        destinationRegion: '目的区域',
        entryPerson: '创建人',
        createDate: '创建日期',
        rateModifier: '修改人',
        modifyDate: '修改日期',
        rateStatus: '运价状态',
        routeName: '航线名称',
        routeCodeSelect: '航线代码',
        terminal: '码头',
        branch: '分公司'
      },

      // 占位符
      placeholders: {
        routeCode: '请输入运价号',
        rateType: '请选择运价类型',
        departurePort: '请选择起运港',
        dischargePort: '请选择卸货港',
        directTransit: '请选择直达/中转',
        transitPort: '请选择中转港',
        transitType: '请选择中转类型',
        shipCompany: '请选择船公司',
        contractNo: '请选择约号',
        spaceStatus: '请选择舱位状态',
        priceStatus: '请选择价格趋势',
        cargoType: '请选择货物类型',
        vesselSchedule: '请选择船期',
        voyage: '请输入航程',
        freeStorageDays: '请输入免柜租期',
        nac: '请选择NAC',
        validPeriod: '请选择有效期范围',
        etd: '请选择ETD范围',
        eta: '请选择ETA范围',
        vesselName: '请输入船名',
        voyageNo: '请输入航次',
        cutoffDate: '请选择截关日范围',
        destinationRegion: '请输入目的区域',
        entryPerson: '请输入创建人',
        createDate: '请选择创建日期范围',
        rateModifier: '请输入修改人',
        modifyDate: '请选择修改日期范围',
        rateStatus: '请选择运价状态',
        routeName: '请选择航线名称',
        routeCodeSelect: '请选择航线代码',
        terminal: '请选择码头',
        branch: '请选择分公司'
      }
    },

    // 尾程运价筛选字段国际化
    lastmileFilterFields: {
      // 标签
      labels: {
        priceMethod: '运价类型',
        status: '运价状态',
        destinationPort: '卸货港',
        agent: '代理名称',
        currency: '货币',
        feeName: '费用名称',
        unit: '单位',
        addressType: '地址类型',
        country: '国家',
        postalCode: '邮编',
        state: '州',
        city: '市',
        district: '区域',
        warehouseCode: '仓库代码'
      },

      // 占位符
      placeholders: {
        priceMethod: '请选择运价类型',
        status: '请选择运价状态',
        destinationPort: '请选择卸货港',
        agent: '请输入代理名称',
        currency: '请选择货币',
        feeName: '请选择费用名称',
        unit: '请选择单位',
        addressType: '请选择地址类型',
        country: '请选择国家',
        postalCode: '请选择邮编',
        state: '请选择州',
        city: '请选择市',
        district: '请选择区域',
        warehouseCode: '请输入仓库代码'
      }
    },

    // 操作
    actions: {
      combinationQuery: '组合方案查询',
      batchImport: '批量导入',
      export: '导出列表',
      customTable: '自定义表格',
      download: '下载',
      copy: '复制',
      search: '查询',
      reset: '重置',
      viewDetail: '查看详情',
      edit: '编辑',
      delete: '删除',
      enable: '启用',
      disable: '禁用',
      // 运价查询特有操作
      query: '查询',
      advancedQuery: '高级查询',
      simpleQuery: '简单查询',
      saveQuery: '保存查询',
      loadQuery: '加载查询',
      clearQuery: '清空查询',
      exportQuery: '导出查询结果',
      shareQuery: '分享查询',
      // 组合查询相关操作
      startCombinationQuery: '开始组合查询',
      stopCombinationQuery: '停止组合查询',
      saveSolution: '保存方案',
      compareSolutions: '对比方案',
      selectBestSolution: '选择最佳方案',
      // 结果处理操作
      viewDetails: '查看详情',
      addToFavorites: '添加到收藏',
      removeFromFavorites: '从收藏移除',
      addToCart: '添加到购物车',
      removeFromCart: '从购物车移除',
      batchOperations: '批量操作 ({count})',
      batchOperationsAll: '批量操作',
      batchExportExcel: '批量导出Excel',
      batchExportCsv: '批量导出CSV',
      exportRate: '导出运价 ({count})',
      exportRateAll: '导出运价',
      batchExport: '批量导出',
      confirmExportTitle: '确认导出',
      confirmExportContent: '是否发起导出任务，导出目前查询条件下的所有运价结果？',
      taskManagerRedirectTitle: '导出提示',
      taskManagerRedirectContent: '导出任务已成功触发，请稍后在任务中心查看。',
      goToTaskManager: '查看任务',
      quickQuotation: '快速报价',
      wobaoQuotation: '沃宝报价'
    },

    // 快速报价
    quickQuotation: {
      title: '快速报价',
      instruction: '您可以修改/复制下面的文本,快速报价',
      priceAdjustment: '基于原价格快速加价',
      priceAdjustmentPlaceholder: '请输入',
      surcharge: '附加费',
      settings: '设置',
      cancel: '取消',
      confirm: '文本报价',
      copySuccess: '报价文本已复制到剪贴板',
      copyFailed: '复制失败，请重试',
      // 报价文本字段
      fields: {
        carrier: '船公司',
        pol: '起运港',
        pod: '卸货港',
        etdEta: '开航/到港',
        vesselVoyage: '船名/航次',
        routeCode: '航线代码',
        directTransit: '直达/中转',
        oceanFreight: '海运费',
        otherCharges: '其他费用',
        surcharge: '附加费用'
      },
      // 自定义文本设置
      customText: {
        title: '自定义文本设置',
        instruction: '此处设置内容将展示在生成的报价文本中',
        enableCustomText: '自定义展示文本',
        textPosition: '文本位置',
        positionTop: '顶部',
        positionBottom: '底部',
        customTextPlaceholder: '请输入自定义文本',
        save: '保存',
        cancel: '取消'
      }
    },

    // 电商运价查询
    ecommerce: {
      title: '电商运价查询',
      filters: {
        pol: '起运港',
        pod: '目的港',
        eta: 'ETA:',
        containerType: '箱型',
        carrier: '船公司',
        etd: 'ETD',
        etdRange: 'ETD范围',
        direct: '直达',
        transit: '中转'
      },
      placeholders: {
        pol: '请选择起运港',
        pod: '请选择目的港',
        containerType: '请选择箱型',
        carrier: '请选择船公司',
        watchMode: '请选择监控方式',
        status: '请选择状态',
        input: '请输入',
        weight: 'KG',
        etdRange: '请选择ETD范围'
      },
      actions: {
        ranking: '运价榜单',
        aiAnalysis: 'AI分析',
        pin: '运价置顶',
        unpin: '取消置顶',
        replacePin: '置换置顶',
        quickQuote: '快速报价',
        priceTrend: '价格趋势',
        arrival: '到港',
        departure: '离港',
        aiAnalysisLabel: 'AI识别',
        batchQuote: '批量报价',
        aiQuote: 'AI 报价单生成',
        priceWatch: '运价监控',
        priceWatchSource: '基于当前查询',
        priceWatchTaskSuffix: '监控',
        priceWatchCategoryCarrier: '承运人',
        priceWatchCategoryPol: '起运港',
        priceWatchCategoryPod: '目的港',
        // 港口名称
        priceWatchPorts: {
          cNSHA: '上海',
          uSLAX: '洛杉矶',
          uSNYC: '纽约',
          cNYTN: '盐田',
          cNSNZ: '深圳',
          hKHKG: '香港',
          cNTXG: '天津',
          cNQDG: '青岛',
          cNXMN: '厦门',
          cNDLC: '大连',
          cNNGB: '宁波',
          cNLJG: '连云港',
          cNSZX: '深圳',
          cNGZO: '广州',
          uSLGB: '长滩',
          uSOAK: '奥克兰',
          nLRTM: '鹿特丹',
          dEHAM: '汉堡',
          gBFXT: '菲利克斯托'
        },
        excelImport: 'Excel导入/处理',
        viewWatchTasks: '查看监控任务'
      },
      labels: {
        pinnedRates: '置顶运价',
        allLoaded: '已加载全部内容',
        loadingMore: '加载中...',
        day: '天',
        receiving: '收货',
        vessel: '船名',
        voyage: '航次',
        lane: '航线',
        basePrice: '基础运费',
        totalPrice: '总计运费',
        departure: '离港',
        arrival: '到港',
        origin: '起运',
        destination: '目的'
      },
      sort: {
        earliest: '最早',
        fastest: '最快',
        cheapest: '最便宜'
      },
      columns: {
        id: '运价ID',
        carrierName: '承运人名称',
        pol: '起运港',
        pod: '目的港',
        transportTerms: '运输条款',
        laneCode: '航线代码',
        etd: 'ETD',
        eta: 'ETA',
        transitType: '中转状况',
        validFrom: '有效起始日期',
        validTo: '有效结束日期',
        spaceStatus: '舱位状态',
        cargoType: '货物类型',
        transitTime: '航程',
        totalPrice: '总运价',
        totalCurrency: '总价币种',
        basePrice: '基础运费',
        baseCurrency: '基价币种',
        vesselName: '船名',
        voyageNo: '航次',
        updateTime: '更新时间',
        surchargeLabel: '附加费标签',
        surchargeAmount: '附加费金额',
        cutoffDate: '截关日期',
        actions: '操作'
      },
      freshness: {
        unknown: '未知',
        unknownTime: '未知时间',
        veryFresh: '极鲜',
        fresh: '新鲜',
        relativelyFresh: '较新',
        withinOneDay: '一天内',
        withinTwoDays: '两天内',
        stale: '陈旧',
        minutesAgo: '{minutes}分钟前更新',
        hoursAgo: '{hours}小时前更新',
        daysAgo: '{days}天前更新'
      },
      quickQuote: {
        title: '快速报价',
        cancel: '取消',
        save: '保存',
        tips: '您可以修改/复制下面的文本，快速报价',
        record: '记录',
        recordIndex: '记录 {index}',
        surchargeDetail: '[附加费明细]',
        surchargeHeader: '费用大类    费用名称    付款方式    计费单位    币种    单价',
        totalEstimate: '总计金额: {currency} {amount} (估算)',
        customText: {
          title: '自定义文本设置',
          info: '此处设置内容将展示在生成的报价文本中',
          enable: '自定义展示文本',
          position: '文本位置',
          top: '顶部',
          bottom: '底部',
          default: '报价如下，请查收。有效期至本月底。',
          aiCopy: 'AI文案',
          generate: '生成文案',
          styles: {
            concise: '简洁紧凑',
            professional: '专业正式',
            friendly: '亲切友好'
          }
        },
        additionalFees: '附加费',
        basicOceanFreight: '基础海运费',
        totalRate: '总运价',
        fixedPriceMarkup: '固定价格加价',
        unifiedMarkup: '全部箱型统一加价:',
        baseMarkup: '基础加价',
        totalMarkup: '总价加价',
        fixedRatioMarkup: '固定比例加价',
        unifiedRatioMarkup: '全部箱型统一加价 (%):',
        baseRatioMarkup: '基础加价比例',
        totalRatioMarkup: '总价加价比例',
        imageQuote: '图片报价',
        textQuote: '文本报价',
        generatingPreview: '正在生成报价预览...',
        generatingBatchPreview: '正在批量生成所有图片...',
        aiMarkupSuccess: 'AI智能批量加价完成',
        copySuccess: '已复制 {count} 条报价文本到剪贴板',
        quoter: '报价人',
        validity: '有效期',
        tabs: {
          aiMarkup: 'AI加价',
          fixedMarkup: '固定价格加价',
          percentMarkup: '固定比例加价'
        },
        labels: {
          allContainerMarkup: '全部箱型统一加价:',
          allContainerMarkupPercent: '全部箱型统一加价 (%):',
          minPrice: '最低价格:',
          maxPrice: '最高价格:',
          and: '且',
          paymentType: '付款方式',
          unit: '计费单位',
          unitBox: '每箱',
          por: '装货地',
          fnd: '目的地',
          sailing: '开航/到港',
          vesselVoyage: '船名/航次',
          markupLimits: '加价限制',
          validity: '有效期'
        },
        columns: {
          type: '箱型',
          basePrice: '基础价格',
          totalPrice: '总价',
          markupBase: '基础加价',
          markupTotal: '总价加价',
          markupBasePercent: '基础加价比例',
          markupTotalPercent: '总价加价比例',
          originFee: '起运港费用',
          destinationFee: '目的港费用',
          otherFee: '其他费用'
        },
        actions: {
          applyAll: '应用所有',
          copyAll: '复制全文',
          exportImage: '导出图片',
          exportAll: '导出全部',
          startAi: '启动AI加价'
        },
        strategy: {
          title: 'AI加价策略',
          balance: '智能平衡模式 (智能平衡)',
          acquisition: '获客优先模式 (低价占市)',
          profit: '利润优先模式 (高溢价)'
        }
      },
      messages: {
        searching: '正在查询...',
        searchFailed: '查询失败',
        searchInterrupted: '查询连接已断开，部分船司结果可能未返回',
        carrierNoData: '【{carriers}】暂无符合数据',
        carrierListSeparator: '、',
        detailNotFound: '未找到对应运价详情',
        dataNotFound: '未找到对应运价数据',
        selectRateFirst: '请先勾选要报价的运价',
        pinSuccess: '成功置顶 {count} 条运价',
        unpinSuccess: '已取消置顶',
        unpinAllSuccess: '已取消全部置顶',
        unpinCountSuccess: '已取消 {count} 条置顶',
        pinFailed: '置顶失败',
        unpinFailed: '取消置顶失败',
        aiQuoteLimit: 'AI报价单最多支持10条运价',
        batchQuoteSuccess: '批量报价创建成功',
        excelImportSuccess: 'Excel导入成功',
        aiQuoteSuccess: 'AI报价单生成成功'
      },
      aiAdvice: {
        title: '运价选择建议',
        subtitle: 'AI 专家实时深度分析',
        strongSuggest: 'AI 强烈建议',
        suggest: 'AI 推荐',
        shortComment: '核心短评',
        reason: '推荐理由',
        total: '总计',
        etd: '预计离港',
        eta: '预计到达'
      },
      aiAssistant: {
        langCode: 'zh_CN',
        name: '运价分析智能助手',
        description: '为您分析运价详情',
        skillPrefix: '运价分析',
        displayText: '根据当前筛选条件与查询到的运价，进行运价分析',
        analyzeSingle: '请帮我分析这条从 {pol} 到 {pod} 的 {carrier} 运价是否划算，给出选择建议。',
        analyzeAll: '请帮我分析当前搜索到的 {count} 条电商运价。'
      },
      ranking: {
        title: '运价榜单',
        back: '返回',
        hotRoutes: '热门航线',
        hotCarriers: '热门船司',
        freightIndex: '运价指数',
        routeTrend: '航线运价趋势',
        up: '上涨',
        down: '下跌',
        stable: '持平',
        day: '日',
        week: '周',
        etdPlaceholder: ['最早ETD', '最晚ETD'],
        top10Routes: 'TOP 10 航线',
        top10Carriers: 'TOP 10 船司',
        expand: '展开',
        collapse: '收起',
        compare: '比对',
        multiCompare: '多表比对',
        multiCompareTitle: '多表比对 ({count}/6)',
        clear: '清空',
        maxCompareWarning: '最多只能比对6张图表',
        addedToCompare: '已添加到比对栏',
        chartLabels: {
          frequency: '查询频率 (%)',
          avgPrice: '平均运价 ($)'
        },
        routeLines: {
          asia: '亚洲线',
          africa: '非洲线',
          americaCanada: '美加线',
          europeMed: '欧地线',
          latinAmerica: '拉美线',
          ausNz: '澳新线'
        },
        originPorts: {
          shanghai: '上海 (CNSHA)',
          ningbo: '宁波 (CNNGB)',
          shenzhen: '深圳 (CNSZX)'
        },
        queryCount: '查询次数',
        avgHeat: '平均热度',
        avgPrice: '平均价格',
        baseWoWRate: 'Base 环率',
        totalWoWRate: 'Total 环率',
        routeTrendShort: '航线趋势',
        daily: '每日',
        weekly: '每周',
        close: '关闭',
        addToCompare: '加入比对'
      },
      detailModal: {
        boxPrices: '各箱型运价',
        costDetail: '费用明细',
        refundFees: '退改费',
        dnd: 'DND',
        priceTrend: '运价趋势图',
        priceTrendTip: '按 ETD 展示同航线、同船司、同箱型的运价趋势',
        totalEstimate: '预估总金额',
        includes: '包含 {categories}',
        tips1: '由于退改费可能随船公司政策变动，以上费用仅供参考。',
        tips2: 'DND免箱期以船公司实际规则为准。',
        hint: '提示',
        totalLogicHint: 'Total费用计算逻辑：海运费+主币种的始发港费用+主币种的目的港需要的预付费用(主币种: 基础海运费的币种)',
        weightHint: '集装箱重量默认：12,000 KG',
        feeName: '费用名目',
        currency: '币种',
        amount: '金额',
        base: '基础运费',
        total: '总计',
        validityPeriod: '有效天数',
        costPerDay: '日租',
        oceanBase: '基础海运费',
        oceanFreight: '海运费',
        oceanExtra: '其他附加费',
        free: '免费',
        categories: {
          OCEAN_BASE: '基础海运费',
          OCEAN_EXTRA: '其他附加费',
          POR: '起运港附加费',
          FND: '目的港附加费',
          OTHERS: '其他费用',
          Freight: '基础海运费',
          Origin: '起运港费用',
          Destination: '目的港费用',
          Others: '其他'
        },
        labels: {
          vessel: '船名',
          voyage: '航次',
          lane: '航线',
          base: '基础',
          total: '合计',
          others: '其他',
          arrival: '到达',
          departure: '离港',
          day: '天'
        },
        paymentTypes: {
          prepaid: '预付',
          collect: '到付'
        },
        units: {
          perBox: '按箱'
        }
      },
      charts: {
        performanceTitle: '船司性价比分析',
        positionTitle: '市场运价分布分析',
        currentItem: '当前分析项',
        valueHigh: '高性价比',
        regularRecommend: '常规推荐',
        boundaryLine: '性价比分界线',
        boundaryTip: '注：虚线为性价比分界线，处于左下角的点代表在相同航程下价格更低，或在相同价格下航程更短，具有更高性价比。',
        average: '平均',
        median: 'P50 (中位数)',
        stdDev: '标准差',
        marketDist: '市场分布',
        percentile: '市场百分位',
        max: '最大值',
        min: '最小值',
        countUnit: '条'
      },
      status: {
        available: '现舱',
        full: '售罄',
        within15Minutes: '15分钟前',
        hoursAgo: '{hours}小时前',
        history: '历史'
      },
      cargoTypes: {
        general: '普货'
      },

      // Price Watch (监控任务)
      priceWatch: {
        // 通用标签
        common: {
          active: '运行中',
          paused: '已暂停',
          triggered: '已触发',
          expired: '已失效',
          normal: '正常',
          edit: '编辑',
          delete: '删除',
          cancel: '取消',
          confirm: '确认',
          save: '保存',
          create: '创建',
          reset: '重置',
          search: '搜索',
          refresh: '刷新',
          actions: '操作',
          status: '状态',
          remark: '备注',
          remarkPlaceholder: '请输入备注信息（选填）',
          yes: '是',
          no: '否',
          all: '全部',
          hide: '隐藏',
          view: '查看',
          noData: '-',
          days: '天',
          hours: '时',
          minutes: '分',
          perDay: '每日',
          fullDay: '全天',
          // 监控方式
          watchModes: {
            active: '主动监控',
            passive: '被动监控',
            both: '两者都启用',
            activeDesc: '系统按设定频率自动查询运价',
            passiveDesc: '复用平台已有查询结果进行触发判断',
            bothDesc: '同时支持主动与被动触发，短时同结果只推送一次'
          },
          // 触发模式
          triggerModes: {
            priceAny: '有价格就推送',
            priceAnyDesc: '无需设定参照价格，有运价变化即推送通知',
            targetPrice: '按目标价格推送',
            targetPriceDesc: '设定目标价格，实际价格高于或低于目标时推送'
          },
          // 频率选项
          frequency: {
            '1h': '每1小时',
            '2h': '每2小时',
            '4h': '每4小时',
            '6h': '每6小时',
            '12h': '每12小时',
            '24h': '每天一次',
            custom: '自定义',
            customInterval: '自定义间隔（小时）',
            hoursUnit: '小时',
            estimatedDaily: '预计每日执行'
          },
          // 对比方向
          directions: {
            below: '低于目标价',
            above: '高于目标价',
            both: '高于或低于目标价'
          },
          // 推送策略
          pushStrategies: {
            trackPrice: '盯价格',
            conditionTrigger: '条件触发'
          },
          // 通知渠道
          notifyChannels: {
            email: '邮件通知',
            wechat: '微信服务号通知',
            workchat: '沃宝通知',
            emailConfig: '邮件通知配置',
            emailPlaceholder: '请输入邮箱地址，多个邮箱用逗号分隔',
            emailTemplate: '邮件模板',
            emailTemplateDefault: '默认模板',
            emailTemplateSimple: '简洁模板',
            emailTemplateDetailed: '详细模板（含趋势图）',
            subscribeWechat: '关注服务号接收运价提醒',
            scanWechatQr: '请使用微信扫码关注 CargoWareX 服务号',
            wechatTips: '关注后，系统将通过服务号向你推送运价变化、目标价命中、监控任务异常等提醒。',
            followed: '已关注',
            skipNow: '暂不关注',
            alreadyFollowed: '已关注',
            workchatConfigured: '沃宝通知已配置',
            workchatDesc: '可推送至企业微信、钉钉、飞书等内部沟通群',
            workchatNotConfigured: '沃宝通知未配置',
            workchatSetup: '此功能需要联系客户配置沃宝。',
            configuredGroups: '已配置群组：',
            notifyDesc: '当价格满足上方触发条件后，系统将通过已选择渠道发送提醒。'
          },
          // 状态选项
          taskStatus: {
            active: '监控中',
            paused: '已暂停',
            triggered: '已触发',
            expired: '已失效'
          },
          // 价格对比
          priceComparison: {
            title: '各箱型价格对比',
            containerType: '箱型',
            targetPrice: '目标价(USD)',
            currentPrice: '当前价(USD)',
            deviation: '偏差',
            status: '状态',
            triggered: '已触发'
          },
          // 触发记录
          triggerRecords: {
            title: '触发记录',
            triggerTime: '触发时间',
            priceAtTrigger: '触发时价格',
            condition: '触发条件',
            notifyStatus: '通知状态',
            notified: '已通知',
            notifyFailed: '通知失败'
          }
        },

        // Account management (监控账号)
        account: {
          modal: {
            create: '新增监控账号',
            edit: '编辑监控账号',
            errorUsage: '请至少勾选一种用途'
          },
          columns: {
            name: '账号名称',
            carrierCode: '对应船公司',
            platformType: '平台类型',
            usage: '账号用途',
            loginAccount: '登录账号',
            loginPassword: '登录密码',
            remark: '备注'
          },
          messages: {
            createSuccess: '创建监控账号成功',
            updateSuccess: '更新监控账号成功',
            createFailed: '添加账号失败',
            updateFailed: '修改账号失败',
            nameRequired: '请输入账号名称',
            carrierRequired: '请选择关联的船公司',
            platformRequired: '请选择平台类型',
            loginRequired: '请输入官网登录账号',
            passwordRequired: '请输入官网登录密码',
            passwordPlaceholder: '请输入密码',
            passwordEditPlaceholder: '留空表示不修改密码',
            namePlaceholder: '例如: 马士基查价主账号',
            carrierPlaceholder: '选择船公司',
            loginPlaceholder: '请输入用户名/邮箱',
            remarkPlaceholder: '如：此账号每日限频50次',
            platformType1: '承运人官网',
            platformType2: '第三方平台',
            platformType3: '内部接口',
            usageQuery: '查询',
            usageWatch: '监控',
            usageBooking: '订舱',
            deleteConfirm: '确定删除该账号吗？',
            deleteSuccess: '账号已删除',
            toggleEnabled: '{name} 已{status}',
            enabled: '启用',
            disabled: '停用'
          }
        },

        // CreateWatchTask
        create: {
          // 分区标题
          sections: {
            monitorConditions: '监控条件',
            monitorSettings: '监控设置',
            pushSettings: '推送设置',
            notificationSettings: '通知设置'
          },
          // 表单标签
          labels: {
            taskName: '任务名称',
            taskNamePlaceholder: '请输入任务名称，留空则按航线自动生成',
            carrier: '承运人（多选）',
            carrierShort: '承运人',
            pol: '起运港（多选）',
            polShort: '起运港',
            pod: '目的港（多选）',
            podShort: '目的港',
            containerType: '箱型',
            containerTypeMulti: '箱型（支持多选）',
            containerTypePlaceholder: '请选择箱型，支持多选',
            monitoringDateRange: '监控时间范围',
            startDate: '开始日期',
            endDate: '结束日期',
            watchMode: '监控方式',
            watchModeTooltip: '系统支持主动监控和被动监控。主动监控会按照设置频率定时查询运价；被动监控会复用平台已有查询结果进行触发判断。同时启用两种模式时，系统会以更早满足条件的结果触发提醒。被动监控无需配置频率，但依赖平台用户的查询行为。',
            activeConfig: '主动监控配置',
            executionAccount: '监控账号',
            executionAccountPlaceholder: '请选择执行账号',
            accountConfig: '监控账号配置',
            frequency: '监控频率',
            dailyStartTime: '每日开始时间（北京时间）',
            dailyStartTimePlaceholder: '选择开始时间',
            dailyEndTime: '每日结束时间（北京时间）',
            dailyEndTimePlaceholder: '选择结束时间',
            estimatedDaily: '预计每日执行',
            dedupEnabled: '重复价格不推送',
            dedupDesc: '同一航线、船司、箱型价格无变化时不重复提醒。',
            workdayOnly: '仅工作日推送',
            workdayOnlyDesc: '非工作日不推送通知。',
            triggerConfig: '价格触发条件',
            triggerMode: '触发模式',
            targetPrice: '目标价格',
            targetPricePlaceholder: '输入目标价',
            comparisonDirection: '对比方向',
            threshold: '阈值',
            thresholdPlaceholder: '触发阈值',
            strategyDesc: '策略说明',
            strategyAnyDesc: '有可用运价即推送，不设价格门槛。',
            // 多箱型目标价
            multiTargetTitle: '目标价格设置列表',
            uniformSet: '一键统一设置',
            batchAdjust: '批量调整',
            batchPercentDown: '统一下调（百分比）',
            batchFixedDown: '统一下调（固定金额）',
            batchPercentUp: '统一上浮（百分比）',
            batchFixedUp: '统一上浮（固定金额）',
            multiTargetHint: '承运人、起运港、目的港根据监控条件自动组合，每个箱型可独立设置目标价格、对比方向与阈值。',
            // 触发条件显示
            triggerCondition: '触发条件：',
            anyPriceCondition: '监控到该航线、船司、箱型有可用运价时即推送通知，不设价格门槛。',
            multiContainerCondition: '各箱型独立对比 — 当某箱型实际价格满足上方设定的条件时触发推送。',
            singleContainerCondition: '实际价格 {direction} 目标价 ${targetPrice} USD 超过 ${threshold} USD 时触发推送',
            historyPriceRef: '历史价格参考',
            showHistory: '查看历史价格参考',
            hideHistory: '隐藏历史价格参考',
            historyTip: '如系统中存在历史价格，显示今年当周运价记录和去年同期周价格；若不存在，基于监控条件自动查询当前运价作为参考。',
            priceTrendChart: '价格趋势图',
            routeLabel: '航线：',
            chartHint: '鼠标悬停查看具体数值 · 实线为当年价格 · 虚线为去年同期价格',
            noHistoryData: '暂无历史价格，已根据监控条件自动查询当前运价作为参考',
            referencePrice: '推荐价格仅供参考，用户可根据实际客户报价策略手动调整。',
            // 邮件配置
            emailSection: '邮件通知配置',
            emailLabel: '邮箱地址',
            emailTemplateLabel: '邮件模板',
            // 备注
            remark: '备注',
            remarkPlaceholder: '请输入备注信息（选填）',
            // 底部按钮
            btnCancel: '取消',
            btnCreate: '创建监控任务',
            btnSave: '保存修改',
            btnConfirmFollow: '我已关注',
            btnSkipFollow: '暂不关注'
          },
          // 消息
          messages: {
            accountLoadFailed: '账号加载失败',
            followSuccess: '已关注服务号，可接收服务号通知',
            followRemoved: '已取消服务号关注',
            selectPolPodFirst: '请先选择至少一个起运港和目的港',
            selectContainerTypeFirst: '请先选择至少一个箱型',
            overwriteConfirm: '确认覆盖',
            overwriteContent: '当前已有手动填写价格，是否重新查询并覆盖？',
            overwriteOk: '确认覆盖',
            overwriteCancel: '取消',
            noRecommendPrice: '暂无推荐价格，请先查询当前价格',
            priceSetSuccess: '已填入{label} ${price} USD',
            applyRecommendSuccess: '已应用 {containerType} 推荐价格，基准价: ${basePrice}，目标价: ${targetPrice}',
            selectPol: '请选择起运港',
            selectPod: '请选择目的港',
            selectCarrier: '请选择承运人',
            selectPolPodCarrier: '请至少选择一个起运港、一个目的港和一个承运人',
            selectContainerType: '请选择至少一个箱型',
            fillTargetPrices: '请设定以下组合的目标价：{items}',
            fillThresholds: '请设定以下组合的阈值：{items}',
            selectAccount: '请选择执行账号',
            validFrequency: '请输入有效的自定义监控频率',
            selectNotifyChannel: '请选择至少一个通知渠道',
            enterEmail: '请输入邮箱地址',
            serviceAccountWarning: '服务号未关注，暂无法推送服务号通知。将优先使用其他已配置的通知渠道。',
            priceQuerySuccess: '价格查询成功，已生成推荐价格',
            uniformTargetTitle: '一键统一目标价',
            uniformTargetContent: '请输入统一目标价（USD），将应用到所有已选箱型：',
            uniformTargetSuccess: '已将所有组合的目标价统一设为 ${price} USD',
            invalidTargetPrice: '请输入有效的目标价格',
            batchAdjustTitle: '请输入调整值',
            batchPercentDownHint: '%（如输入5表示下调5%）',
            batchFixedDownHint: 'USD（如输入100表示下调$100）',
            batchPercentUpHint: '%（如输入5表示上浮5%）',
            batchFixedUpHint: 'USD（如输入100表示上浮$100）',
            batchAdjustSuccess: '已批量调整所有组合的目标价',
            selectPolPodQuery: '请先选择至少一个起运港和目的港后再查询当前价格',
            selectCtQuery: '请先选择至少一个箱型后再查询当前价格',
            queryPriceSuccess: '价格查询成功',
            createSuccess: '监控任务创建成功',
            updateSuccess: '监控任务修改成功',
            createFailed: '创建失败，请重试',
            updateFailed: '修改失败，请重试',
            prefillSuccess: '已自动填入电商运价查询条件'
          }
        },

        // ImportWatchTask
        import: {
          alert: '批量导入监控任务，支持一次性创建多个监控。请先下载模板，按模板格式填写后上传。',
          downloadSection: {
            title: '下载导入模板',
            desc: '模板包含必填字段说明和示例数据',
            button: '下载模板'
          },
          uploadSection: {
            button: '上传 Excel 文件',
            hint: '支持 .xlsx、.xls 格式，单次最多导入 100 条',
            singleFileLimit: '单次只能上传一个文件'
          },
          parsing: {
            tip: '正在解析 Excel 文件...'
          },
          result: {
            title: '识别结果',
            total: '共 {count} 条',
            success: '成功 {count} 条',
            failed: '失败 {count} 条',
            successTab: '成功列表 ({count})',
            failedTab: '失败列表 ({count})',
            createConfirm: '确认创建 {count} 个监控任务'
          },
          table: {
            rowNumber: '行号',
            pol: '起运港',
            pod: '目的港',
            carrier: '承运人',
            containerType: '箱型',
            watchMode: '监控方式',
            pushStrategy: '推送策略',
            basePrice: '基准价格',
            failReason: '失败原因',
            suggestion: '建议',
            trackPrice: '盯价格',
            conditionTrigger: '条件触发'
          },
          messages: {
            downloadSuccess: '模板下载成功！',
            parseSuccess: '文件解析完成',
            parseSuccessMock: '文件解析完成（Mock）',
            createSuccess: '成功创建 {count} 个监控任务',
            createFailed: '创建失败，请稍后重试'
          },
          // 修复建议
          fixSuggestions: {
            invalidPol: '请检查港口代码格式，如 CNSHA',
            invalidPod: '请检查港口代码格式，如 USLAX',
            invalidCarrier: '请使用标准承运人代码，如 MSK、COSCO',
            invalidContainerType: '支持的箱型：20GP、40GP、40HC、45HC',
            invalidBasePrice: '请输入数字，如 2850',
            missingFields: '请检查起运港、目的港、承运人、箱型是否填写'
          },
          errors: {
            invalidPol: '起运港代码无效',
            invalidPod: '目的港代码无效',
            invalidCarrier: '承运人代码无效',
            invalidContainerType: '箱型无效',
            invalidBasePrice: '基准价格格式错误',
            missingFields: '缺少必填字段',
            polRequired: '起运港为必填项',
            polNotFound: '起运港代码 {pol} 在系统中不存在',
            podRequired: '目的港为必填项',
            podNotFound: '目的港代码 {pod} 在系统中不存在',
            carrierNotFound: '船公司代码/名称 {carrier} 在系统中不存在',
            containerTypeRequired: '箱型为必填项',
            containerTypeNotSupported: '箱型 {type} 在系统中不支持或未启用',
            targetPricePositive: '目标价格必须为正数',
            targetPriceInvalid: '目标价格格式不正确',
            watchModeRequired: '监控方式为必填项',
            watchModeInvalid: '未知监控方式: {mode}',
            activeFrequencyRequired: '主动监控模式下，监控频率为必填项',
            activeFrequencyInvalid: '监控频率格式不正确 (支持如 1h, 2h, 4h, 6h, daily)',
            watchTimeRangeInvalid: '每日监控时间段格式必须为 HH:mm-HH:mm',
            notifyEmailRequired: '通知渠道含邮件时，邮箱为必填项',
            notifyEmailInvalid: '包含非法邮箱格式: {emails}',
            fixSuggestion: '请根据错误提示修正 Excel 对应行后重新上传解析。'
          },
          // ImportWatchModal
          modal: {
            steps: {
              templateAndImport: '下载模板并导入',
              confirmImport: '确认导入'
            },
            templateSection: {
              title: '模板与导入功能',
              downloadBtn: '下载批量监控模板',
              desc1: '可下载标准模板后批量导入数据，系统将自动解析并生成监控任务。',
              desc2: '支持直接上传符合字段要求的文件，解析成功后进入确认导入。',
              uploadHint: '点击或拖拽文件到此处上传',
              uploadFormat: '支持 .xlsx, .xls 格式，文件大小不超过 10MB',
              parsing: '正在识别并解析...',
              parseSuccess: '解析成功，共识别 {count} 条数据',
              retryParse: '重新解析',
              reupload: '重新上传',
              downloadStandardTemplate: '下载标准模板',
              parseBtn: '识别并解析'
            },
            templateFields: {
              title: '模板字段说明',
              fieldName: '字段名称',
              required: '是否必填',
              desc: '填写说明',
              example: '示例值',
              requiredYes: '必填',
              requiredConditional: '条件必填',
              requiredNo: '非必填',
              nextStep: '下一步',
              polDesc: '支持港口代码或中文名，多个用逗号分隔',
              podDesc: '支持港口代码或中文名，多个用逗号分隔',
              carrierDesc: '支持船司代码或名称，多个用逗号分隔',
              containerTypeDesc: '20GP / 40GP / 40HC / 45HC',
              targetPriceDesc: '用于价格触发判断',
              watchModeDesc: 'active / passive / both',
              frequencyDesc: '主动监控时必填：1h / 2h / 4h / 6h / daily',
              watchTimeRangeDesc: '限制执行或推送时间',
              notifyChannelsDesc: 'email / service_account',
              notifyTargetDesc: '根据通知渠道填写',
              remarkDesc: '补充说明',
              polExample: 'CNSHA,CNNGB / 上海,宁波',
              podExample: 'USLAX,USLGB / 洛杉矶,长滩',
              carrierExample: 'MSK,MSC / 马士基,MSC',
              containerTypeExample: '40HC',
              targetPriceExample: '2500',
              watchModeExample: 'both',
              frequencyExample: '2h',
              watchTimeRangeExample: '09:00-18:00',
              notifyChannelsExample: 'service_account',
              notifyTargetExample: 'sales@example.com',
              remarkExample: '重点客户航线'
            },
            result: {
              totalLabel: '总条数',
              successLabel: '成功识别',
              failedLabel: '识别失败',
              creatableLabel: '可创建任务',
              failedWarning: '系统已识别上传文件中的任务数据。成功数据可直接创建监控任务，失败数据不会创建任务，请根据失败原因修改后重新上传。',
              tabAll: '全部（{count}）',
              tabSuccess: '可创建任务（{count}）',
              tabFailed: '识别失败（{count}）'
            },
            table: {
              rowNum: '行号',
              dataPreview: '数据预览',
              failReason: '失败原因',
              suggestion: '处理建议',
              action: '操作',
              success: '成功',
              failed: '失败',
              pushStrategyTarget: '按目标价推送',
              pushStrategyAny: '有价格即推送'
            },
            editForm: {
              pol: '起运港',
              pod: '目的港',
              carrier: '船司',
              containerType: '箱型',
              targetPrice: '目标价格',
              watchMode: '监控方式',
              frequency: '监控频率',
              watchTimeRange: '每日监控时间段',
              notifyChannels: '通知渠道',
              notifyTarget: '接收对象/邮箱',
              remark: '备注',
              polPlaceholder: '港口代码或中文名',
              podPlaceholder: '港口代码或中文名',
              carrierPlaceholder: '船司代码',
              containerTypePlaceholder: '选择箱型',
              targetPricePlaceholder: '目标价格',
              watchModePlaceholder: '选择监控方式',
              frequencyPlaceholder: '选择频率',
              watchTimeRangePlaceholder: '如 09:00-18:00',
              notifyTargetPlaceholder: '邮箱地址或联系人',
              remarkPlaceholder: '备注信息',
              email: '邮件',
              serviceAccount: '服务号',
              watchModeActive: '主动监控',
              watchModePassive: '被动监控',
              watchModeBoth: '两者都启用',
              edit: '编辑',
              delete: '删除',
              deleteConfirm: '确定删除该条数据吗？',
              saveAndRevalidate: '保存并重新校验',
              cancel: '取消'
            },
            actions: {
              downloadFailed: '下载失败数据',
              summary: '将创建 {creatable} 条成功任务，{failed} 条失败数据不会创建。',
              reuploadFile: '重新上传文件',
              confirmCreate: '确认创建监控任务'
            },
            messages: {
              selectFileFirst: '请先选择文件',
              parseApiEmpty: '解析接口返回数据为空',
              parseFailedTitle: '文件解析失败',
              parseFailedMsg: '系统读取文件出错，请核对模板后重新上传。',
              reuploadTitle: '重新上传文件',
              reuploadContent: '重新上传将替换当前解析结果，是否继续？',
              reuploadOk: '确认重新上传',
              reuploadCancel: '取消',
              validatePass: '第{row}行校验通过，已移至可创建任务',
              validateFail: '第{row}行校验未通过：{error}',
              deleteSuccess: '第{row}行已删除',
              downloadTemplateSuccess: '批量监控模板已下载，请按模板格式填写后上传。',
              downloadTemplateFailed: '下载模板失败',
              noFailedData: '没有失败数据',
              failedDataDownloaded: '失败数据已下载',
              createSuccess: '批量监控任务已创建成功！',
              noCreatable: '没有可创建的监控任务',
              createFailed: '保存监控任务失败，请重试',
              taskNameSuffix: '监控'
            },
            watchModeLabels: {
              active: '主动监控',
              passive: '被动监控',
              both: '两者都启用'
            },
            validation: {
              polEmpty: '起运港为空',
              polEmptySuggestion: '请补充起运港后重新校验',
              podEmpty: '目的港为空',
              podEmptySuggestion: '请补充目的港后重新校验',
              invalidContainerType: '箱型不合法',
              invalidContainerTypeSuggestion: '请选择系统支持的箱型：20GP/40GP/40HC/45HC',
              invalidWatchMode: '监控方式不合法',
              invalidWatchModeSuggestion: '请选择正确的监控方式',
              activeMissingFrequency: '主动监控缺少频率',
              activeMissingFrequencySuggestion: '请填写 1h / 2h / 4h / 6h / daily 后重新校验',
              invalidEmail: '邮箱格式错误',
              invalidEmailSuggestion: '请更正邮箱格式后重新校验'
            },
            csvHeader: '行号,起运港,目的港,承运人,箱型,监控方式,失败原因,处理建议',
            csvFilename: '批量导入失败数据.csv',
            templateFilename: '批量监控模板.xlsx'
          }
        },

        // WatchTaskList
        list: {
          filters: {
            searchPlaceholder: '搜索任务名称',
            statusPlaceholder: '状态筛选',
            watchModePlaceholder: '监控方式',
            refresh: '刷新'
          },
          columns: {
            taskName: '任务名称',
            pol: '起运港',
            pod: '目的港',
            carrier: '承运人',
            containerType: '箱型',
            watchMode: '监控方式',
            pushStrategy: '推送策略',
            activeFrequency: '监控频率',
            dailyStartTime: '监控时间段（北京时间）',
            basePrice: '基准价格',
            targetPrice: '目标价格',
            latestPrice: '最近价格',
            priceChange: '价格变化',
            notifyChannels: '通知渠道',
            source: '创建来源',
            status: '状态',
            lastTriggerTime: '最近触发',
            actions: '操作'
          },
          actions: {
            edit: '编辑',
            pause: '暂停',
            resume: '恢复',
            viewResult: '查看结果',
            delete: '删除',
            deleteConfirm: '确定删除该监控任务吗？',
            pauseConfirm: '确定暂停该监控任务吗？',
            resumeConfirm: '确定恢复该监控任务吗？'
          },
          status: {
            active: '监控中',
            paused: '已暂停',
            triggered: '已触发',
            expired: '已失效',
            activeTag: '监控中',
            pausedTag: '已暂停',
            triggeredTag: '已触发',
            expiredTag: '已失效'
          },
          // 弹窗
          resultModal: {
            title: '监控结果 - {taskName}',
            taskName: '任务名称',
            status: '状态',
            pol: '起运港',
            pod: '目的港',
            carrier: '承运人',
            containerType: '箱型',
            basePrice: '基准价格',
            latestPrice: '最近价格'
          },
          // 价格变化显示
          priceUp: '↑{change}%',
          priceDown: '↓{change}%',
          messages: {
            paused: '已暂停',
            resumed: '已恢复',
            pausedMock: '已暂停（Mock）',
            resumedMock: '已恢复（Mock）',
            deleteSuccess: '删除成功',
            deleteFailed: '删除失败',
            deleteSuccessMock: '删除成功（Mock）',
            pauseFailed: '暂停失败',
            resumeFailed: '恢复失败'
          },
          // 页面头部 & 操作按钮
          page: {
            title: '运价监控任务列表',
            importBtn: '批量导入监控',
            createBtn: '创建监控任务'
          },
          // 批量导入结果提示
          importAlert: {
            title: '批量导入完成：成功创建 {successCount} 条监控任务',
            titleFailed: '，{failedCount} 条失败',
            viewImported: '查看本次导入任务',
            batchEditStart: '批量编辑并启动',
            viewFailures: '查看失败详情'
          },
          // 从电商运价页带入的数据提示
          importedData: {
            title: '已带入 {count} 条选中运价，可基于选中运价创建监控任务',
            titleNoRates: '已带入当前电商运价查询条件，可用于创建监控任务',
            source: '来源：',
            sourceValue: '电商运价查询',
            pol: '起运港：',
            pod: '目的港：',
            carrier: '承运人：',
            containerType: '箱型：',
            all: '全部',
            selectedRates: '已选运价：',
            count: '{count} 条',
            createFromSelected: '基于选中运价创建',
            createFromCurrent: '基于当前条件创建',
            clearImported: '清除带入条件'
          },
          // 批量操作栏
          batchBar: {
            selected: '已选 {count} 条',
            selectAllPage: '全选当前页',
            allSelectedPage: '已全选当前页',
            clearSelection: '取消选择',
            hint: '勾选任务后可批量启动、暂停、编辑或立即检测',
            batchStart: '批量启动',
            startSuccess: '成功启动 {count} 个任务',
            startFailed: '批量启动任务失败',
            batchPause: '批量暂停',
            pauseSuccess: '成功暂停 {count} 个任务',
            pauseFailed: '批量暂停任务失败',
            batchEdit: '批量编辑',
            editSuccess: '成功编辑 {count} 个任务',
            editFailed: '批量编辑任务失败',
            more: '更多',
            batchDetect: '立即检测',
            detectOnlyActive: '只有「监控中」且开启「主动监控」的任务可以立即检测，请重新选择',
            detectSuccess: '成功检测 {success} 个任务，失败 {failed} 个',
            detectFailed: '批量检测任务失败',
            batchDelete: '批量删除',
            deleteSuccess: '成功删除 {count} 个任务',
            deleteFailed: '批量删除任务失败',
            batchExport: '导出任务',
            exportFailed: '导出任务失败'
          },
          // 批量操作弹窗
          batchModals: {
            startTitle: '批量启动监控任务',
            startAnalysis: '本次选中任务共 <strong>{count}</strong> 条，分析如下：',
            startable: '可启动',
            startableDesc: '{count} 条 — 当前状态为「已暂停」，可立即启动',
            startConfirm: '确认后将仅启动「可启动」的 {count} 条任务，其余自动跳过。',
            pauseTitle: '批量暂停监控任务',
            pauseTotal: '本次选中任务共 <strong>{count}</strong> 条。',
            willPause: '将暂停',
            willPauseDesc: '{count} 条 — 当前状态为「监控中」',
            skip: '跳过',
            skipDesc: '{count} 条 — 已是「已暂停」或「已失效」状态，无需操作',
            pauseConfirm: '暂停后任务将不再执行监控，历史监控记录保留。确认暂停 {count} 条任务？',
            deleteTitle: '批量删除监控任务',
            deleteConfirm: '确认删除选中的 {count} 条监控任务？此操作不可撤销。',
            deleteAfter: '删除后：',
            deletePermanent: '监控任务将永久移除，无法恢复',
            deleteHistory: '历史监控记录将被保留',
            deleteNotify: '已配置的通知将停止发送',
            detectTitle: '批量立即检测',
            detectTotal: '将对选中的 <strong>{count}</strong> 条任务立即执行一次价格检测。',
            detectDesc: '立即检测不改变原有监控频率，仅新增一次手动检测记录。检测完成后将更新最近价格和价格变化。',
            // 批量编辑抽屉
            editTitle: '批量编辑监控任务',
            editAlert: '批量编辑只会修改已勾选字段，未勾选字段将保持原值不变。当前影响 {count} 条任务。',
            editFrequency: '监控频率',
            editTimeRange: '监控时间段',
            editStartTime: '开始时间',
            editEndTime: '结束时间',
            editWatchMode: '监控方式',
            editNotifyChannels: '推送渠道',
            editRecipient: '通知接收人',
            editRecipientPlaceholder: '输入接收人邮箱或账号',
            editTriggerStrategy: '触发策略',
            editTargetRule: '目标价规则',
            editUnifiedTarget: '统一目标价格',
            editUnifiedTargetPlaceholder: '输入统一目标价',
            editPercentOff: '下浮百分比',
            editPercentOffPlaceholder: '如 5',
            editFixedDown: '下调固定金额',
            editFixedDownPlaceholder: '输入下调金额',
            previewTitle: '修改预览',
            previewDesc: '预计影响 <strong>{count}</strong> 条任务，将修改以下字段：',
            noChanges: '未勾选任何字段，不会产生修改。',
            btnPreview: '预览影响',
            btnSave: '确认保存',
            btnCancel: '取消',
            // 目标价规则
            targetRules: {
              keep: '不修改',
              unified: '统一设置',
              percentOff: '按基准价下浮百分比',
              fixedDown: '按当前目标价下调固定金额'
            },
            // 触发策略
            triggerStrategies: {
              conditionTrigger: '条件触发',
              trackPrice: '盯价格',
              priceChange: '价格波动'
            },
            // 监控方式（批量编辑）
            watchModes: {
              active: '主动监控',
              passive: '被动盯价',
              both: '两者都启用'
            },
            // 通知渠道（批量编辑）
            notifyChannelLabels: {
              email: '邮件通知',
              wechat: '企业微信',
              wobot: '沃宝机器人',
              service_account: '服务号通知'
            }
          },
          // 查看结果抽屉
          resultDrawer: {
            title: '监控结果详情 - {taskName}',
            basicInfo: '任务基础信息',
            taskName: '任务名称',
            taskNo: '任务编号',
            status: '状态',
            pol: '起运港',
            pod: '目的港',
            carrier: '承运人',
            containerType: '箱型',
            watchMode: '监控方式',
            pushStrategy: '推送策略',
            execAccount: '执行账号',
            notifyChannels: '通知渠道',
            email: '邮件',
            wechat: '企业微信',
            wobot: '沃宝机器人',
            createTime: '创建时间',
            priceInfo: '价格信息',
            basePrice: '基准价格',
            latestPrice: '最近价格',
            priceChange: '价格变化',
            changeAmount: '变化幅度',
            noResult: '暂无监控结果，请等待下次查询',
            lastTriggerTime: '最近触发时间',
            compareConditions: '比对条件与最新状态',
            noCompareData: '暂无采集到的最新比对数据，请稍后或点击列表“检测”手动触发爬取。',
            triggered: '已触发通知',
            notTriggered: '未触发',
            currentPrice: '当前价格',
            targetPrice: '目标价格',
            compareDirection: '比对方向',
            threshold: '波动阈值',
            priceDiff: '价差',
            tabLogs: '执行历史日志',
            tabHistory: '历史均价参考与趋势',
            logStats: '比对统计',
            statsCollect: '采集',
            statsTrigger: '触发',
            weeklyComparisonTitle: '本周历史同期价格比对：',
            weeklyAverage: '本周平均价',
            lastYearAverage: '去年同期价',
            yoyChange: '同比涨跌幅',
            currentRouteRefPrice: '当前航线最新参考价明细：',
            noHistoryData: '暂无该监控任务的历史均价参考数据',
            priceTrendChart: '价格趋势变动图',
            directionBelow: '低于目标价',
            directionAbove: '高于目标价',
            directionBoth: '高于或低于',
            triggerTypeActive: '定时主动',
            triggerTypePassive: '被动联动',
            triggerTypeManual: '手动检测',
            executeStatusSuccess: '成功',
            executeStatusExecuting: '执行中',
            executeStatusFailed: '失败',
            conditionMet: '已满足推送条件',
            conditionMetDesc: '当前价格 {desc}，已触发推送通知',
            conditionNotMet: '当前价格未达到触发条件',
            conditionNotMetDesc: '当前价格未满足 {strategy} 的推送条件',
            thresholdReached: '已达到设定阈值',
            updated: '已更新',
            // 最近监控记录
            logSection: '最近监控记录',
            logLoading: '加载中...',
            logTime: '执行时间',
            logTriggerType: '触发类型',
            logActive: '主动监控',
            logPassive: '被动触发',
            logManual: '手动',
            logResult: '执行结果',
            logSuccess: '成功',
            logFailed: '失败',
            logExecuting: '执行中',
            logPriceCount: '查到运价数',
            logTriggerCount: '触发条件数',
            logError: '错误信息'
          },
          // 导入失败详情抽屉
          failureDrawer: {
            title: '导入失败详情',
            total: '共 {count} 条数据导入失败，详情如下：',
            rowNum: '行号',
            pol: '起运港',
            pod: '目的港',
            carrier: '承运人',
            containerType: '箱型',
            watchMode: '监控方式',
            errorMsg: '失败原因',
            suggestion: '处理建议',
            defaultSuggestion: '请检查数据后重新导入'
          },
          // 空状态
          empty: '暂无监控任务，可通过创建监控任务或批量导入生成。',
          // 筛选无匹配
          filterNoMatch: '当前筛选条件下暂无匹配的监控任务，请',
          filterClear: '清空筛选条件',
          filterNoMatchAfter: '后查看全部任务。'
        }
      }
    },

    // 整箱运价查询
    fcl: {
      title: '整箱运价查询',
      actions: {
        combinationQuery: '组合方案查询',
        generatePdf: '生成报价单',
        viewQuotationRecords: '查看报价记录'
      },
      messages: {
        viewDetailFailed: '无法查看详情：缺少记录ID',
        inquiryRequired: '电询',
        validFrom: '至 {endDate}',
        validTo: '{beginDate} 起',
        unknown: '未知',
        noData: '-'
      },
      // 状态枚举
      enums: {
        spaceStatus: {
          smooth: '畅接',
          normal: '正常',
          singleApply: '单票申请',
          overbooked: '爆舱',
          notAccepting: '不接',
          limited: '紧张',
          suspended: '停航',
          inquiry: '询盘'
        },
        priceTrends: {
          rising: '价格上涨',
          falling: '价格下调',
          stable: '价格稳定'
        },
        status: {
          draft: '草稿',
          normal: '正常',
          published: '发布',
          expired: '失效',
          invalid: '失效',
          offline: '下架',
          disabled: '禁用'
        },
        rateTypes: {
          contract: '合约价',
          spot: 'SPOT电商'
        },
        cargoTypes: {
          general: '普货',
          dangerous: '危险品',
          frozen: '冷冻货',
          special: '特殊货',
          steelCoil: '钢卷',
          liquid: '液体货',
          chemical: '化工品',
          textile: '纺织品'
        },
        transitTypes: {
          direct: '直达',
          transit: '中转'
        },
        // 校验消息
        validations: {
          loadingPortSameAsDestination: '起运港和卸货港不能相同',
          destinationPortSameAsLoading: '卸货港和起运港不能相同'
        },
        // 导出运价弹窗
        exportPriceDetailModal: {
          palletNature: '货盘性质',
          cargoReadyTime: '货好时间',
          client: '委托单位',
          inquiryEnterprise: '询价企业',
          detailAddress: '详细地址'
        }
      },
      // 表格列配置
      tableColumns: {
        priceNo: '运价号',
        pol: '起运港',
        pod: '卸货港',
        carrierId: '船公司',
        status: '状态'
      },

      // 详情页面配置
      detail: {
        // 字段标签
        fields: {
          voyage: '航程',
          carrier: '船公司',
          contractNo: '约号',
          nac: 'NAC',
          freeContainerDays: '免用箱',
          freeStorageDays: '免堆存',
          validPeriod: '有效期',
          overweightRemarks: '超重说明',
          receivingInstructions: '接货特殊说明',
          remarks: '备注'
        },
        // 占位符
        placeholders: {
          inputVoyage: '请输入航程(天)',
          selectCarrier: '请选择船公司',
          selectContractNo: '请选择约号',
          selectNac: '请选择NAC',
          inputFreeContainerDays: '请输入免用箱(天)',
          inputFreeStorageDays: '请输入免堆存(天)',
          startDate: '开始日期',
          endDate: '结束日期',
          inputOverweightRemarks: '请输入超重说明',
          inputReceivingInstructions: '请输入接货特殊说明',
          inputRemarks: '请输入备注',
          inputShipName: '请输入船名',
          inputVoyageNumber: '请输入航次',
          selectVesselSchedule: '请选择班期',
          selectPlaceOfDelivery: '请选择交货地',
          selectPortOfDischarge: '请选择卸货港',
          selectLaneId: '请选择主干航线',
          inputLaneCode: '请输入航线代码',
          priceNoPlaceholder: '后端自动生成，格式：FCL2506250001',
          priceNoCopyPlaceholder: '复制后将重新生成，格式：FCL2506250001'
        },
        // 中转港
        transitPorts: {
          first: '第一中转港',
          second: '第二中转港',
          third: '第三中转港',
          selectFirst: '请选择第一中转港',
          selectSecond: '请选择第二中转港',
          selectThird: '请选择第三中转港'
        },
        // 消息
        messages: {
          selectCarrier: '请选择船公司',
          selectValidPeriod: '请选择有效期',
          selectRateType: '请选择运价类型',
          selectDeparturePort: '请选择起运港',
          selectDischargePort: '请选择卸货港',
          saveFirst: '请先保存数据',
          loadDataFailed: '加载数据失败',
          copyDataLoadFailed: '复制数据加载失败',
          invalidApiResponse: 'API响应格式不正确',
          invalidCopyApiResponse: '复制数据API响应格式不正确',
          unknownError: '未知错误',
          missingFeeId: '缺少费用ID',
          containerSettingsUpdated: '箱型设置已更新'
        },
        // 区域标题
        sections: {
          ddSettings: 'D&D'
        },
        // 模态框
        modals: {
          selectContainerTypes: '选择要在运价表格中显示的箱型'
        },
        // 页面标题
        pageTitles: {
          create: '新增整箱运价',
          edit: '编辑整箱运价',
          view: '运价详情'
        },
        // 运价详情
        rateDetails: {
          nonContainerBilling: '非按箱型计费',
          containerBillingTitle: '按箱型计费',
          feeNamePlaceholder: '请选择费用名称',
          autoFill: '自动填充',
          priceInputPlaceholder: '请输入价格'
        },
        // 星期配置
        weekdays: {
          monday: '周一',
          tuesday: '周二',
          wednesday: '周三',
          thursday: '周四',
          friday: '周五',
          saturday: '周六',
          sunday: '周日'
        }
      }
    },

    // 拼箱运价查询
    lcl: {
      title: '拼箱运价查询',
      actions: {
        combinationQuery: '组合方案查询',
        generatePdf: '生成报价单',
        viewQuotationRecords: '查看报价记录'
      },
      messages: {
        viewDetailFailed: '无法查看详情：缺少记录ID',
        inquiryRequired: '电询',
        validFrom: '至 {endDate}',
        validTo: '{beginDate} 起',
        unknown: '未知',
        noData: '-'
      }
    },

    // 港前运价查询
    preport: {
      title: '港前运价查询',
      tableConfigName: '港前运价查询表格配置',
      actions: {
        combinationQuery: '组合方案查询'
      },
      messages: {
        viewDetailFailed: '无法查看详情：缺少记录ID',
        inquiryRequired: '电询',
        validFrom: '至 {endDate}',
        validTo: '{beginDate} 起',
        unknown: '未知',
        noData: '-'
      },
      // 状态枚举
      enums: {
        status: {
          draft: '草稿',
          published: '发布',
          invalid: '失效',
          offline: '下架',
          disabled: '禁用'
        },
        priceTypes: {
          contract: '合约价',
          spot: 'SPOT电商'
        },
        cargoTypes: {
          general: '普货',
          dangerous: '危险品',
          frozen: '冷冻货',
          special: '特殊货'
        },
        // 详情配置
        detail: {
          regionSelection: {
            noSelection: '请选择地区信息'
          },
          portInfo: {
            etdPlaceholder: '请选择预计开船日',
            etaPlaceholder: '请选择预计到港日'
          }
        }
      }
    },

    // 尾程运价查询
    lastmile: {
      title: '尾程运价查询',
      tableConfigName: '尾程运价表',
      actions: {
        combinationQuery: '组合方案查询'
      },
      messages: {
        viewDetailFailed: '无法查看详情：缺少记录ID',
        inquiryRequired: '电询',
        validFrom: '至 {endDate}',
        validTo: '{beginDate} 起',
        unknown: '未知',
        noData: '-'
      },
      // 状态枚举
      enums: {
        status: {
          draft: '草稿',
          normal: '正常',
          expired: '过期',
          offline: '下架'
        },
        priceTypes: {
          contract: '合约价',
          spot: 'SPOT电商'
        },
        addressTypes: {
          warehouse: '仓库',
          port: '港口',
          city: '城市',
          district: '区域'
        }
      }
    },

    // 自定义表格
    customTable: {
      title: '表头设置'
    },

    // 组合查询
    combination: {
      title: '组合方案查询',
      description: '查询多种运价组合方案',
      // 页面头部
      header: {
        back: '返回',
        pageTitle: '组合方案查询',
        portPrice: '港前价格',
        trunkPrice: '干线价格',
        lastMilePrice: '尾程价格'
      },
      // 步骤
      steps: {
        step1: {
          number: '1',
          title: '填写查询条件',
          description: '配置查询参数'
        },
        step2: {
          number: '2',
          title: '选择匹配运价',
          description: '选择合适方案'
        }
      },
      // 查询条件表单
      form: {
        basicInfo: {
          title: '基本信息',
          countryOrigin: '起运国家',
          countryOriginPlaceholder: '请选择起运国',
          cityOrigin: '起运城市',
          cityOriginPlaceholder: '请选择起运城市',
          countryDest: '卸货国家',
          countryDestPlaceholder: '请选择卸货国',
          cityDest: '卸货城市',
          cityDestPlaceholder: '请选择卸货城市',
          pol: '起运港',
          polPlaceholder: '请选择起运港',
          pod: '卸货港',
          podPlaceholder: '请选择卸货港',
          directType: '直达/中转',
          directTypeOptions: {
            notSpecified: '不指定',
            direct: '直达',
            transit: '中转'
          },
          route: '航线',
          routePlaceholder: '请选择航线',
          carrier: '船公司',
          carrierPlaceholder: '请选择船公司',
          originCountry: '起运国家',
          originCountryPlaceholder: '请选择起运国家',
          destinationCountry: '目的国家',
          destinationCountryPlaceholder: '请选择目的国家',
          supplier: '供应商',
          supplierPlaceholder: '请选择供应商',
          onePrice: '一口价',
          serviceType: '服务类型',
          serviceTypePlaceholder: '请输入服务类型',
          cargoType: '货物类型',
          cargoTypePlaceholder: '请选择货物类型'
        },
        client: '委托单位',
        addressInfo: {
          title: '地址信息',
          pol: '起运港',
          polPlaceholder: '请选择起运港',
          pod: '卸货港',
          podPlaceholder: '请选择卸货港',
          pot: '中转港',
          potPlaceholder: '请选择中转港',
          departureAirport: '起运机场',
          departureAirportPlaceholder: '请选择起运机场',
          arrivalAirport: '目的机场',
          arrivalAirportPlaceholder: '请选择目的机场',
          transitAirport: '中转机场',
          transitAirportPlaceholder: '请选择中转机场'
        },
        containerInfo: {
          title: '箱型箱量',
          containerType: '箱型',
          containerTypePlaceholder: '请选择箱型',
          quantity: '数量',
          quantityPlaceholder: '请输入数量',
          addContainer: '添加箱型',
          removeContainer: '删除箱型'
        },
        timeInfo: {
          title: '时间信息',
          etd: 'ETD',
          etdPlaceholder: '请选择ETD',
          eta: 'ETA',
          etaPlaceholder: '请选择ETA'
        },
        buttons: {
          search: '查询',
          reset: '重置',
          next: '下一步',
          back: '上一步'
        }
      },
      // 查询结果
      results: {
        title: '查询结果',
        summary: '查询摘要',
        summaryItems: {
          route: '航线',
          pol: '起运港',
          pod: '卸货港',
          carrier: '船公司',
          cargoType: '货物类型',
          containers: '箱型箱量'
        },
        noResults: '暂无符合条件的组合方案',
        loading: '正在查询中...',
        totalCount: '共找到 {count} 个组合方案',
        // 运价类型标签
        rateTypes: {
          portPrice: '港前价格',
          trunkPrice: '干线价格',
          lastMilePrice: '尾程价格'
        },
        // 状态标签
        status: {
          loading: '加载中',
          loaded: '已加载',
          error: '加载失败'
        }
      },
      // 消息提示
      messages: {
        searchSuccess: '查询完成',
        searchFailed: '查询失败',
        noDataFound: '未找到符合条件的运价数据',
        selectRateType: '请至少选择一种运价类型',
        fillRequiredFields: '请填写必填字段',
        invalidFormData: '表单数据无效，请检查输入',
        // 运价加载相关
        candidateLoadIncomplete: '运价候选未完整加载或查询期间数据发生变化，请重新查询',
        candidateLimitExceeded: '单段候选超过 {candidateLimit} 条，请收窄查询条件；本次未展示部分结果',
        combinationLimitExceeded: '合法组合超过 {combinationLimit} 组，请收窄查询条件；本次未展示部分结果',
        trunkRatesLoaded: '干线运价数据加载完成',
        portRatesLoaded: '港前运价数据加载完成',
        lastMileRatesLoaded: '尾程运价数据加载完成',
        // 错误消息
        loadTrunkRatesFailed: '干线运价数据加载失败',
        loadPortRatesFailed: '港前运价数据加载失败',
        loadLastMileRatesFailed: '尾程运价数据加载失败',
        // 验证消息
        atLeastOneRateType: '请至少勾选一种价格类型（港前价格、干线价格或尾程价格）',
        atLeastOneContainer: '请至少添加一个箱型',
        selectContainerType: '请选择第{index}行的箱型',
        inputContainerQuantity: '请输入第{index}行的数量',
        atLeastOneRate: '请至少选择一个运价方案',
        selectClientRequired: '请选择委托单位',
        combinationGenerated: '组合方案生成成功，已选择 {count} 个运价方案'
      },
      // 地址相关
      address: {
        loadingPoint: {
          title: '装箱门点',
          addressType: '地址类型',
          thirdParty: '第三方地址',
          warehouse: '仓库',
          countryPostcode: '国家与邮编',
          country: '请选择国家',
          postalCode: '请输入邮编',
          selectWarehouse: '请选择仓库',
          administrative: '行政区划',
          province: '请选择省份',
          city: '请选择城市',
          district: '请选择区县',
          detail: '详细位置',
          street: '请选择街道',
          community: '请选择社区',
          detailAddress: '详细地址',
          detailAddressPlaceholder: '请输入详细地址'
        },
        delivery: {
          title: '尾程送货地址',
          addressType: '地址类型',
          thirdParty: '第三方地址',
          warehouse: '仓库',
          countryPostcode: '国家与邮编',
          selectCountry: '请选择国家',
          inputPostcode: '请输入邮编',
          stateCityRegion: '州市区域',
          selectState: '请选择州',
          selectCity: '请选择市',
          selectRegion: '请选择区域',
          detailAddress: '详细地址',
          detailAddressPlaceholder: '请输入详细地址',
          warehouseCode: '仓库',
          selectWarehouse: '请选择仓库'
        }
      },
      // 表格相关
      table: {
        trunkRates: '干线运价',
        portRates: '港前运价',
        lastMileRates: '尾程运价',
        clickToSelect: '请点击下方行以选择运价内容',
        containerInfo: '箱型箱量信息',
        close: '关闭',
        copyText: '复制文本'
      },
      // 弹窗相关
      modal: {
        exportQuotation: '导出预览',
        quickQuotation: '快捷文字报价预览',
        quotationDescription: '以下是系统根据您选择的运价生成的快捷报价文本，您可以直接复制发送给客户。',
        quotationTitle: '运价方案报价单',
        queryTime: '查询时间',
        transportType: '运输类型',
        containerInfo: '箱型箱量',
        pol: '起运港',
        pod: '卸货港',
        eta: 'ETA:',
        carrier: '船公司',
        trunkRate: '干线运价',
        portRate: '港前运价',
        lastMileRate: '尾程运价',
        selected: '已选择',
        note: '注：此报价基于当前查询条件生成，具体价格请以实际运价为准',
        contactService: '如需详细报价，请联系客服',
        selectClient: '选择委托单位'
      },
      // 状态和枚举
      enums: {
        // 货物类型
        cargoTypes: {
          fcl: '整箱',
          lcl: '拼箱',
          air: '空运'
        },
        // 箱型
        containerTypes: {
          '20gp': '20GP',
          '40gp': '40GP',
          '40hc': '40HC'
        },
        // 空间状态
        spaceStatus: {
          sufficient: '充足',
          tight: '紧张',
          unknown: '未知'
        },
        // 价格趋势
        priceTrend: {
          rising: '上涨',
          falling: '下跌',
          stable: '持平',
          unknown: '未知'
        },
        // 运价状态
        rateStatus: {
          valid: '有效',
          invalid: '失效',
          pending: '待审核',
          unknown: '未知'
        },
        // 运费类型
        freightType: {
          contract: '合约价',
          spot: 'SPOT电商'
        },
        // 直达标志
        directFlag: {
          direct: '直达',
          transit: '中转'
        },
        // 价格方法
        priceMethod: {
          direct: '直拖',
          branchLine: '支线',
          seaRail: '海铁'
        },
        // 支线类型
        branchLine: {
          haiding: '海定支线',
          zhapu: '乍浦支线',
          huzhou: '湖州海铁',
          yiwu: '义乌海铁'
        },
        // 配送地址类型
        deliveryAddressType: {
          thirdParty: '第三方地址',
          warehouse: '仓库',
          unknown: '未知'
        },
        // 状态
        status: {
          draft: '草稿',
          normal: '正常',
          expired: '过期',
          offline: '下架',
          unknown: '未知'
        }
      },
      // 按钮和操作
      actions: {
        next: '下一步',
        back: '返回',
        search: '查询',
        reset: '重置',
        bookingNow: '立即订舱',
        printQuotation: '打印报价单',
        generateCombination: '生成组合方案',
        exportQuotation: '导出报价',
        copyQuotationText: '复制报价文本',
        lastMileRate: '尾程运价: {priceNo}',
        viewDetail: '查看详情'
      },
      card: {
        trunkRate: '干线运价: {priceNo}',
        portRate: '港前运价: {priceNo}',
        lastMileRate: '尾程运价: {priceNo}',
        viewDetail: '查看详情'
      },
      portBinding: {
        title: '港口绑定关系',
        preportRate: '港前运价',
        lastmileRate: '尾程运价',
        addressFilled: '已填写地址',
        loadingPointDefault: '装箱门点地址',
        deliveryDefault: '末端配送地址',
        pol: '起运港',
        pod: '卸货港',
        trunkLabel: '干线',
        trunkTransport: '干线运输',
        notSelected: '未选择',
        polEqRule: '← 港前.起运港 = 干线.起运港',
        podEqRule: '干线.卸货港 = 尾程.卸货港 →',
        trunkDefaultDesc: '起运港 → 卸货港'
      },
      linkedResults: {
        matchLabels: {
          allIn: 'ALL in',
          precise: '精准匹配',
          free: '自由组合'
        },
        title: '三段联运运价组合',
        count: '（共 {count} 条）',
        autoMatchDesc: '按节点及运价匹配规则生成全部合法组合，可排序并分页查看',
        sortLabel: '排序：',
        sortTotalPrice: '综合费用',
        sortTransitDays: '时效',
        sortTrunkPrice: '干线运费',
        preportTransport: '港前运输',
        trunkTransport: '干线运输',
        lastmileTransport: '尾程运输',
        trunkLabel: '干线',
        pol: '起运港',
        pod: '卸货港',
        noMatch: '⚠️ 暂无匹配',
        launchInquiry: '发起询价',
        transitDays: '{days}天',
        routeSummary: '{duration} | {directType}',
        directOrTransit: '直达/中转',
        preportFreight: '港前金额',
        trunkFreight: '干线金额',
        lastmileFreight: '尾程金额',
        totalCost: '综合费用',
        viewSchedule: '查看船期',
        viewDetail: '查看明细',
        bookNow: '立即下单',
        noLinkedResults: '暂无匹配的三段联运运价组合',
        suggestion: '建议：',
        suggestion1: '1. 检查起运港和卸货港是否正确',
        suggestion2: '2. 尝试更换港前地址或尾程地址',
        suggestion3: '3. 发起询价获取专属报价'
      },
      detailModal: {
        title: '三段联运运价明细',
        pathPreport: '① 港前运输',
        pathPol: '② 起运港',
        pathTrunk: '③ 干线运输',
        pathPod: '④ 卸货港',
        pathLastmile: '⑤ 尾程运输',
        tabTrunk: '干线运价',
        tabPreport: '港前运价',
        tabLastmile: '尾程运价',
        noTrunkRate: '暂无干线运价',
        noPreportRate: '暂无港前运价',
        noLastmileRate: '暂无尾程运价',
        totalFormula: '综合费用 = 干线运费 + 尾程运费 + 港前运费'
      },
      scheduleModal: {
        title: '查看船期',
        carrier: '船公司',
        pol: '起运港',
        pod: '卸货港',
        validPeriod: '有效期'
      }

    },

    // 消息提示
    messages: {
      searchSuccess: '查询完成',
      tableSettingsApplied: '表格设置已应用',
      combinationQueryPending: '组合方案查询功能开发中...',
      batchImportPending: '批量导入功能开发中...',
      exportPending: '导出功能开发中...',
      noAccessibleTab: '当前没有可访问的运价页签',
      clickTabToLoad: '点击"{tab}"标签页加载内容',
      lclPending: 'LCL拼箱运价管理功能开发中...',
      lclFeatures: '将支持拼箱运价的增删改查、批量操作等功能',
      airPending: '空运运价管理功能开发中...',
      airFeatures: '将支持空运运价的增删改查、批量操作等功能',
      // 通用消息
      loading: '加载中...',
      loadSuccess: '加载成功',
      loadFailed: '加载失败',
      saveSuccess: '保存成功',
      saveFailed: '保存失败',
      quoteSaved: '报价已保存',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败',
      operationSuccess: '操作成功',
      operationFailed: '操作失败',
      // 确认消息
      confirmDelete: '确定要删除这条记录吗？',
      confirmEnable: '确定要启用这条记录吗？',
      confirmDisable: '确定要禁用这条记录吗？',
      confirmBatchDelete: '确定要删除选中的 {count} 条记录吗？',
      confirmBatchEnable: '确定要启用选中的 {count} 条记录吗？',
      confirmBatchDisable: '确定要禁用选中的 {count} 条记录吗？',
      // 验证消息
      requiredField: '此字段为必填项',
      invalidFormat: '格式不正确',
      invalidEmail: '邮箱格式不正确',
      invalidPhone: '手机号格式不正确',
      invalidDate: '日期格式不正确',
      // 运价查询特有消息
      queryInProgress: '正在查询中，请稍候...',
      queryCompleted: '查询完成',
      queryNoResults: '未找到符合条件的运价数据',
      rateNotFound: '未找到运价信息',
      queryError: '查询过程中发生错误',
      selectRateFirstToQuote: '请先选择要报价的运价记录',
      selectRateFirstToGeneratePdf: '请先选择要生成报价单的运价记录',
      priceTrendPending: '运价趋势功能开发中...',
      // 组合查询相关
      combinationQueryStarted: '开始组合方案查询',
      combinationQueryCompleted: '组合方案查询完成',
      combinationQueryFailed: '组合方案查询失败',
      // 运价类型选择
      selectRateTypes: '请选择要查询的运价类型',
      atLeastOneRateType: '至少需要选择一种运价类型',
      // 查询条件验证
      invalidQueryConditions: '查询条件无效，请检查输入',
      missingRequiredFields: '缺少必填字段，请完善查询条件',
      // 数据加载状态
      dataLoading: '数据加载中...',
      dataLoaded: '数据加载完成',
      dataLoadFailed: '数据加载失败',
      // 分页相关
      pageInfo: '第 {current} 页，共 {total} 条',
      pageSizeChanged: '每页显示 {size} 条',
      // 排序相关
      sortBy: '排序方式',
      sortAsc: '升序',
      sortDesc: '降序',
      // 筛选相关
      filterApplied: '筛选条件已应用',
      filterCleared: '筛选条件已清空',
      filterReset: '筛选条件已重置',
      // 组合查询新增
      atLeastOneRate: '请至少选择一个运价内容',
      combinationGenerated: '已成功生成组合方案，共包含 {count} 项运价',
      selectTrunkRateFirst: '请先选择干线运价',
      selectClientRequired: '请选择委托单位',
      rateInfoNotFound: '未找到选中的运价信息'
    },
    salesQuotation: {
      tabs: {
        fcl: '整箱',
        lcl: '拼箱',
        air: '空运'
      },
      quickQuote: {
        title: '快速报价',
        customerLabel: '报价客户（选填）：',
        customerPlaceholder: '搜索/选择客户',
        customerModeLabel: '报价客户：',
        customerModeName: '客户名称',
        customerModeLevel: '客户等级',
        customerSearchPlaceholder: '搜索并选择客户（选填）',
        levelPlaceholder: '选择客户等级',
        levelMarkupTitle: '客户等级加价',
        levelMarkupDesc: '按所选客户等级匹配销售加价规则，自动计算单价加价',
        levelMarkupEmpty: '暂无匹配的等级加价规则',
        smartMarkupRuleLabel: '加价规则',
        manualEditBanner: '已手动修改报价文本',
        resetToGenerated: '恢复自动生成',
        oceanMarkupTitle: '海运费加价',
        airMarkupTitle: '空运费加价',
        onlyForPricedTypes: '仅对有价格的箱型生效',
        noMarkupContainerType: '无可加价箱型',
        lclOnlyForUnitPrice: '对销售单价加价（按计费单位，非箱型）',
        lclUnitMarkup: '单价加价',
        lclNoUnitPrice: '无可加价单价',
        lclMinCharge: '最低一票',
        airOnlyForUnitPrice: '对各重量段单价与最低收费加价（M / N / 45+ …）',
        airUnitMarkup: '单价加价',
        airNoUnitPrice: '无可加价单价',
        airMinCharge: '最低收费',
        smartMarkupTitle: '智能加价',
        smartMarkupDesc: '选择客户后匹配拼箱销售加价规则，自动计算加价金额',
        smartMarkupDescByLevel: '选择客户等级后匹配销售加价规则，自动计算加价金额',
        smartMarkupDescByLevelAir: '选择客户等级后匹配已启用空运加价的销售规则（密度×重量段矩阵，按 N 价段）',
        smartMarkupRulePlaceholder: '选择加价规则',
        btnConfirmCopy: '确认复制',
        copiedSuccess: '报价文本已复制到剪贴板',
        surchargeTitle: '附加费',
        defaultCheckedLabel: '默认选中',
        defaultSurchargeTooltip: '开启后每次打开弹窗自动勾选全部附加费',
        surchargeOcean: '海运附加费',
        surchargeOrigin: '起运港费用',
        surchargeDest: '目的港费用',
        surchargeAirTrunk: '干线附加费',
        surchargeAirOrigin: '起飞地费用',
        surchargeAirDest: '目的地费用',
        surchargeEmpty: '（暂无匹配附加费）',
        remarksTitle: '备注内容',
        defaultRemarksTooltip: '开启后每次打开弹窗自动勾选全部备注',
        remarkPickup: '接货特殊说明',
        remarkFreeDetention: '免箱期',
        remarkFreeDemurrage: '免堆期',
        remarkOverweight: '超重说明',
        remarkWeightLimit: '限重',
        remarkOther: '备注',
        customMessageTitle: '自定义留言',
        positionLabel: '位置：',
        posTop: '顶部',
        posBottom: '底部',
        customPlaceholder: '输入自定义留言内容…',
        btnGeneratePdf: '生成报价单',
        btnConfirmQuote: '确认报价（复制+保存）',
        btnCancel: '取消',
        savedSuccess: '报价已复制并保存，记录编号：{quoteNo}',
        saveFailed: '操作失败，请重试',
        textCarrier: '船公司',
        textAirline: '航空公司',
        textPol: '起运港',
        textPod: '卸货港',
        textAirPol: '起运机场',
        textAirPod: '目的机场',
        textTransitType: '运输方式',
        textValidPeriod: '有效期',
        textOceanFreight: '海运费',
        textOceanFreightDetail: '海运费费用明细',
        textBaseFreight: '基础海运费',
        textAirFreight: '空运费',
        textSailings: '参考船期（共{count}条）',
        textPickupNote: '接货特殊说明：{note}',
        textFreeDetentionNote: '免箱期：{days}天',
        textFreeDemurrageNote: '免堆期：{days}天',
        textWeightLimitNote: '限重：{weight} KG',
        textOtherRemark: '备注：{remark}',
        textSurchargeMin: '最低{v}',
        textSurchargeMax: '最高{v}',
        textIncluded: '已含',
        textCountIn: '计入',
        textPerTicket: '/票',
        textDirect: '直达',
        textTransit: '中转',
        airTierM: 'M(最低)',
        airTierN: 'N',
        airTier45: '45+',
        airTier100: '100+',
        airTier300: '300+',
        airTier500: '500+',
        airTier700: '700+',
        airTier1000: '1000+',
        airTier2000: '2000+'
      },
      wobaoQuotation: {
        title: '沃宝报价',
        formatTitle: '选择报价格式',
        linkFormat: '链接格式',
        posterFormat: '海报格式',
        posterPending: '海报生成功能暂未接入',
        previewTitle: '实时预览',
        wecomSend: '企业微信群发送',
        wecomPending: '数字人员工接口待接入',
        remarkPickup: '接货特殊说明',
        remarkOverweight: '超重备注',
        remarkFreeDetention: '免箱期',
        remarkOther: '其他备注',
        hardcodedPickup: '■ 接货特殊说明：请提前与我司联系确认接货时间及地点，超重/超限货物请提前告知。',
        hardcodedOverweight: '■ 超重备注：单件货物超过 2 吨或单件超过 3 米需加收超重/超长附加费，具体金额以实际测量为准。',
        hardcodedFreeDetention: '■ 免箱期：目的港免箱期以船公司实际政策为准，超出免箱期产生的费用由收货人承担。',
        hardcodedOther: '■ 其他备注：本报价不含货物运输保险费，建议客户自行购买。运价如有变动，以订舱时确认为准。',
        customMessageTitle: '自定义留言',
        messageTitle: '留言',
        posTop: '顶部',
        posBottom: '底部',
        customMessagePlaceholder: '给客户的留言（选填）',
        customerNameMode: '客户名称',
        customerLevelMode: '客户等级',
        customerLevelPlaceholder: '选择客户等级',
        baseOceanFreight: '基础海运费',
        baseFreight: '基础运费',
        prepaid: '预付',
        collect: '到付',
        payMethod: '付款方式',
        orig: '原价',
        quoted: '报价',
        perTicket: '按票',
        quickMarkupTitle: '快速加价',
        quickMarkupDesc: '仅对运价有价格箱型生效',
        quickMarkupDescLcl: '基础海运费按单价加价，附加费按票加价',
        quickMarkupBtn: '快速加价',
        markupConfigTitle: '快速加价配置',
        markupConfigHintTitle: '配置说明',
        markupConfigHint: '加价基于基础费用进行加价',
        oceanFreightMarkup: '海运费加价',
        unitPriceMarkup: '单价',
        oceanSurchargeMarkup: '海运附加费加价',
        originSurchargeMarkup: '起运港费用加价',
        destSurchargeMarkup: '目的港费用加价',
        perTicketMarkup: '按票加价',
        resetMarkupConfig: '重置默认',
        saveMarkupConfig: '保存配置',
        resetMarkupSuccess: '已重置为默认配置',
        saveMarkupSuccess: '配置已保存',
        saveMarkupFailed: '配置保存失败',
        linkEmailSent: '报价链接已发送至客户邮箱',
        emailDialogTitle: '邮箱发送',
        emailDialogToLabel: '收件邮箱',
        emailDialogToExtra: '支持输入多个邮箱，用逗号、分号或换行分隔',
        emailDialogToPlaceholder: '请输入收件邮箱，多个邮箱请用逗号/分号/换行分隔',
        emailDialogRequired: '请输入收件邮箱',
        emailDialogInvalid: '存在无效邮箱地址，请检查后重试',
        emailLevelTooltip: '请先选择客户等级',
        quickMarkupApplied: '已按配置加价',
        surchargeCategoryOff: '请先开启对应附加费类别',
        customerSelectedBanner: '已选择 {n} 个客户，报价金额已按客户等级调整',
        customerLevelSelectedBanner: '已选择客户等级 {level}，报价金额已按客户等级调整',
        baseOceanFreightMarkup: '基础海运费加价',
        baseAirFreightMarkup: '基础空运费加价',
        baseFreightMarkup: '基础运费加价',
        quoteLinkLabel: '报价链接：',
        customerShortLabel: '客户：'
      },
      linkDetail: {
        pageTitle: '销售报价详情',
        docTitle: '报价单',
        dateLabelShort: '日期',
        routeTitle: '航线信息',
        routeFallback: '航线',
        feeItemFallback: '费用项',
        previewTokenBlocked: '预览链接尚不能直接打开报价详情，请先在沃宝报价中发送邮件，使用邮件中的正式链接访问',
        missingToken: '链接无效：缺少访问凭证',
        notFound: '报价不存在或已失效',
        expired: '报价链接无效或已过期'
      },
      generatePdf: {
        title: '生成报价单',
        docTitle: '报 价 单',
        noLabel: '编号：',
        dateLabel: '日期：',
        routeInfo: '运价信息',
        routeInfoPrefix: '运价 {n} — 运价信息',
        recordDivider: '运价 {n}',
        departurePort: '起运港',
        transitPort: '中转港',
        arrivalPort: '卸货港',
        placeOfDelivery: '收货地',
        deliveryAddress: '派送地址',
        destinationPort: '目的港',
        departureAirport: '起运机场',
        destinationAirport: '目的机场',
        departureStation: '起运站',
        destinationStation: '目的站',
        voyageDays: '航程 {days} 天',
        voyageHours: '航程 {hours} 小时',
        validPeriod: '有效期：',
        grandTotal: '总价',
        scheduleSection: '船期信息',
        vessel: '船名',
        voyage: '航次',
        laneCode: '航线代码',
        customsCutoff: '截关时间',
        portCutoff: '截港时间',
        transitDays: '航程(天)',
        oceanFreightSection: '海运费',
        airFreightSection: '空运费',
        feeName: '费用名称',
        unit: '单位',
        billingUnit: '计费单位',
        containerTypePageHint: '箱型 {from}-{to} / 共 {total} 种',
        quickMarkupTip: '按箱：20GP+25/40GP+50/40HC+50；按票：+25',
        oceanFreightMarkupTip: '20GP+25 / 40GP+50 / 40HC+50',
        currency: '币种',
        origPrice: '{label}原价',
        quotedPrice: '{label}报价',
        perTicketOrig: '票原价',
        perTicketMarkup: '票加价',
        perTicketQuoted: '票报价',
        perTicketFee: '费用(票)',
        specialNote: '特殊备注',
        surchargeIncluded: '附加费（含）',
        surchargeIncludedTip: '费用已包含在总价，无需额外收费',
        surchargeExtra: '附加费（不含）',
        surchargeExtraTip: '费用不包含在总价，需额外收费',
        remarksSection: '备注内容',
        remarksPlaceholder: '备注内容将在勾选选项后自动填入，可直接编辑修改…',
        extraRemarks: '附加说明/条款：',
        extraRemarksPlaceholder: '输入附加说明或条款内容…',
        customerSection: '报价客户：',
        addCustomer: '添加客户',
        customerPlaceholder: '搜索/选择客户',
        contactPlaceholder: '选择联系人',
        emailPlaceholder: '邮箱：选择联系人后自动带入',
        surchargeLabel: '附加费：',
        surchargeOcean: '海运附加费',
        surchargeOrigin: '起运港费用',
        surchargeDest: '目的港费用',
        surchargeAirTrunk: '干线附加费',
        surchargeAirOrigin: '起飞地费用',
        surchargeAirDest: '目的地费用',
        remarksLabel: '备注内容：',
        pickupRemark: '接货特殊说明',
        overweightRemark: '超重说明',
        freeDetentionRemark: '免箱期',
        freeDemurrageRemark: '免堆期',
        weightLimitRemark: '限重',
        otherRemark: '备注',
        authorizedSignature: '授权签字',
        savedSuccess: '报价单已保存，记录编号：{quoteNo}',
        saveFailed: '保存失败，请重试',
        emailSent: '报价单已发送至：{recipients}，记录编号：{quoteNo}',
        downloadSuccess: '报价单已下载，记录编号：{quoteNo}',
        downloadFailed: 'PDF 生成失败，请重试',
        notLoaded: '报价单内容未加载',
        remarkPickupPrefix: '• 接货特殊说明：{note}',
        remarkFreeDetentionPrefix: '• 免箱期：{days}天',
        remarkFreeDemurragePrefix: '• 免堆期：{days}天',
        remarkWeightLimitPrefix: '• 限重：{weight} KG',
        remarkOtherPrefix: '• 备注：{remark}',
        lclCompanyFallback: '控制塔物流',
        lclCustomerLabel: '客户：',
        lclOrigUnitPrice: '原单价',
        lclQuotedUnitPrice: '报单价',
        lclMinCharge: '最低一票',
        lclDownloadPdf: '下载 PDF',
        lclDownloadSuccess: '报价单已下载，编号：{quoteNo}',
        airCompanyFallback: '控制塔物流',
        airCustomerLabel: '客户：',
        airOrigUnitPrice: '原 N 价',
        airQuotedUnitPrice: '报 N 价',
        airOrigPrice: '原价',
        airQuotedPrice: '报价',
        airMinCharge: '最低收费',
        airDownloadPdf: '下载 PDF',
        airDownloadSuccess: '报价单已下载，编号：{quoteNo}',
        btnCancel: '取消',
        btnSave: '保存记录',
        btnEmail: '发送邮箱',
        btnDownload: '下载 PDF',
        emailTooltip: '请先选择客户联系人以获取收件邮箱'
      },
      linkView: {
        docTitle: '报价单',
        date: '日期',
        message: '留言',
        rateN: '运价 {n}',
        routeInfo: '航线信息',
        voyageHoursText: '航程 {hours} 小时',
        voyageDaysText: '航程 {days} 天',
        validPeriod: '有效期：',
        airFreight: '空运费',
        baseFreight: '基础运费',
        oceanFreight: '海运费',
        prepaid: '预付',
        densityLevel: '密度等级',
        currency: '币种',
        feeName: '费用名称',
        billingUnit: '计费单位',
        origUnitPrice: '原单价',
        quotedUnitPrice: '报单价',
        orig: '原价',
        quoted: '报价',
        feeItem: '费用项',
        perTicket: '按票',
        total: '总价',
        direct: '直达',
        transit: '中转',
        surchargeOcean: '海运附加费',
        surchargeOrigin: '起运港费用',
        surchargeDest: '目的港费用',
        surchargeAirTrunk: '干线附加费',
        surchargeAirOrigin: '起飞地费用',
        surchargeAirDest: '目的地费用',
        departureAirport: '起运机场',
        transitAirport: '中转机场',
        destinationAirport: '目的机场',
        departurePort: '起运港',
        transitPort: '中转港',
        destinationPort: '目的港',
        deliveryAddress: '派送地址',
        placeOfDelivery: '收货地',
        route: '航线',
        destAirport: '目的机场',
        destStation: '目的站',
        destSeaport: '目的港',
        originAirport: '起运机场',
        originStation: '起运站',
        originSeaport: '起运港',
        previewLinkHint: '预览链接尚不能直接打开报价详情，请先在沃宝报价中发送邮件，使用邮件中的正式链接访问',
        invalidToken: '链接无效：缺少 token',
        notFound: '报价不存在或已失效',
        expiredOrInvalid: '报价链接无效或已过期'
      },
      pdfDetail: {
        title: 'PDF报价单详情',
        typeTag: 'PDF报价单',
        quotationNoLabel: '报价编号：',
        typeLabel: '报价类型：',
        createdAtLabel: '报价时间：',
        createdByLabel: '报价人：',
        surchargeIncludedLabel: '含附加费：',
        orderTimeLabel: '下单时间：',
        markupSnapshot: '加价策略（快照）：',
        rateSnapshot: '运价快照（{count}条）',
        recordDivider: '运价 {n}',
        surchargeDetail: '附加费明细（{count}项）',
        surchargeIncludedTip: '费用已包含在总价，无需额外收费（{count}项）',
        surchargeExtraTip: '费用不包含在总价，需额外收费（{count}项）',
        remarks: '备注信息',
        extraClauses: '附加说明/条款',
        createOrder: '基于此报价下单',
        noRateData: '该报价记录无运价数据',
        generating: '正在生成报价单 {no} 的PDF文件…',
        downloaded: '报价单 {no} PDF 已下载',
        emailSent: '报价单 {no} 已发送{route}',
        orderCreating: '正在基于报价 {no} 创建订单',
        colPriceNo: '运价号',
        colCarrier: '船公司',
        colPol: '起运港',
        colPod: '卸货港',
        colOrigPrice: '{label}底价',
        colQuotedPrice: '{label}报价',
        colValidPeriod: '有效期',
        colFeeName: '费用名称',
        colFeeType: '费用类别',
        colBilling: '计费',
        colOrigTicket: '按票底价',
        colQuotedTicket: '按票报价',
        chargeTypeOcean: '海运附加费',
        chargeTypeOrigin: '起运港费用',
        chargeTypeDest: '目的港费用',
        chargeTypeOther: '附加费',
        feeConfirmTitle: '费用确认',
        feeItem: '费用项目',
        feeType: '费用类型',
        billingUnit: '计费单位',
        perTicketFee: '费用(票)',
        seaFreight: '海运费',
        btnClose: '关闭',
        btnEmail: '发送邮箱',
        btnDownload: '下载PDF',
        confirmOk: '确认下单',
        confirmCancel: '取消',
        quotationLabel: '报价单：',
        markupLabel: '加价：',
        yes: '是',
        no: '否',
        receivableTag: '应收',
        containerUnit: '箱',
        ticketUnit: '票'
      },
      quickDetail: {
        title: '快速报价详情',
        typeTag: '快速报价',
        quotationNoLabel: '报价编号：',
        typeLabel: '报价类型：',
        createdAtLabel: '报价时间：',
        surchargeIncludedLabel: '含附加费：',
        orderTimeLabel: '下单时间：',
        markupSnapshot: '加价策略（快照）：',
        rateSnapshot: '运价快照（{count}条）',
        recordDivider: '运价 {n}',
        remarks: '备注信息',
        extraClauses: '附加说明/条款',
        quoteText: '报价文本：',
        diffLabel: '文本修改记录',
        diffBadge: '已手动修改',
        diffBefore: '修改前（自动生成）',
        diffAfter: '修改后（最终报价）',
        createOrder: '基于此报价下单',
        noRateData: '该报价记录无运价数据',
        orderCreating: '正在基于报价 {no} 创建订单',
        feeConfirmTitle: '费用确认',
        feeConfirmOkText: '确认下单',
        feeConfirmCancelText: '取消',
        quotationLabel: '报价单：',
        markupLabel: '加价：',
        seaFreight: '海运费',
        feeItem: '费用项目',
        feeType: '费用类型',
        billingUnit: '计费单位',
        colRateId: '运价ID',
        colPol: '起运港',
        colPod: '卸货港',
        colOrigPrice: '{label}底价',
        colQuotedPrice: '{label}报价',
        colValidPeriod: '有效期',
        btnClose: '关闭',
        yes: '是',
        no: '否',
        receivableTag: '应收',
        containerUnit: '箱',
        markupDetailLabel: '└ 加价明细：'
      },
      enum: {
        source: {
          internal: '内部询价',
          external: '外部询价',
        },
      },
      list: {
        colQuotationNo: '报价编号',
        colType: '类型',
        colSource: '来源',
        colClient: '报价客户',
        colClientPlaceholder: '请选择报价客户',
        colRateSummary: '运价摘要',
        colMainPrice: '主要价格',
        colSurcharge: '附加费',
        colCreatedAt: '报价时间',
        colCreatedDate: '报价日期',
        colCreatedBy: '报价人',
        colStatus: '状态',
        colRemarks: '备注',
        colAction: '操作',
        includeSurcharge: '含附加费',
        excludeSurcharge: '不含',
        orderIndex: '下单 {n}',
        orderEnterprise: '委托单位：',
        orderTime: '下单时间：',
        orderCreatedBy: '下单人：',
        noOrderRecord: '暂无下单记录',
        actionView: '查看',
        actionPlaceOrder: '下单',
        actionSendEmail: '发送邮箱',
        actionDownloadPdf: '下载PDF',
        rateCount: '等 {count} 条运价',
        sendEmailSuccess: '邮件发送成功',
        sendEmailFailed: '邮件发送失败'
      },
      rateSelection: {
        title: '选择运价下单',
        tip: '报价记录包含 {count} 条运价,请选择一条运价进行下单操作',
        rateNumber: '运价 {n}',
        validPeriod: '有效期:',
        vesselVoyage: '船名/航次:',
        transitTag: '中转',
        payableFees: '应付费用(底价)',
        receivableFees: '应收费用(报价)',
        confirmOrder: '确认下单',
        expired: '有效期已过,无法下单',
        close: '关闭',
        colFeeItem: '费用项目',
        colBillingUnit: '计费单位',
        colTicketFee: '费用(票)',
        seaFreight: '海运费',
        containerUnit: '箱'
      }
    },
    express: {
      fields: {
        loadMode: '装载模式',
        queryDate: '查询日期',
        carrier: '快递公司',
        serviceType: '服务类型',
        billingModel: '计费模型',
        priceNo: '运价号',
        source: '来源',
        status: '状态',
        accountNo: '账号',
        office: '分公司',
        routeType: '路线类型',
        currency: '币种',
        paymentTerm: '付费条款',
        country: '国家',
        province: '省/州',
        city: '城市',
        district: '区/县',
        township: '乡/镇/街道',
        detailAddress: '详细地址',
        postalCode: '邮编',
        originCountry: '发货国家',
        originProvince: '发货省/州',
        originCity: '发货城市',
        originDistrict: '发货区/县',
        originTownship: '发货乡/镇/街道',
        originDetailAddress: '发货详细地址',
        originPostalCode: '发货邮编',
        originWarehouse: '发货仓库',
        destCountry: '目的国家',
        destProvince: '目的省/州',
        destCity: '目的城市',
        destDistrict: '目的区/县',
        destTownship: '目的乡/镇/街道',
        destDetailAddress: '目的详细地址',
        destPostalCode: '目的邮编',
        destWarehouse: '目的仓库',
        onePrice: '一口价',
        cargoType: '货物类型',
        pieces: '件数',
        cargoDimensions: '货物尺寸(cm)',
        actualWeight: '实际重量(kg)',
        lengthCm: '长(cm)',
        widthCm: '宽(cm)',
        heightCm: '高(cm)',
        totalVolume: '总体积(m3)',
        totalWeightTon: '总重量(t)',
        pickupRequired: '是否提货',
        deliveryRequired: '是否送货',
        expectedVehicleType: '期望车型',
        pricingPreference: '整车计费方式',
        billingWeight: '计费重量',
        volumeWeight: '体积重',
        validity: '有效期',
        billingMethod: '计费方式',
        volumetricFactor: '体积重系数',
        minBillingWeight: '最小计费重量',
        pickupFee: '提货费',
        deliveryFee: '送货费',
        loadingFee: '装卸费',
        vehicleType: '车型',
        vehicleCapacity: '车型载重',
        vehicleVolume: '车型容积',
        firstWeight: '首重',
        firstWeightThreshold: '首重重量',
        firstWeightPrice: '首重价格',
        additionalWeightUnit: '续重单位',
        additionalWeightPrice: '续重价格',
        weightTierAdditionalWeightPrice: '续重单价',
        weightTierMinCharge: '最低收费（总价）',
        unitPrice: '单价',
        unitPriceVolume: '体积单价',
        tripPrice: '整车一口价',
        kmPrice: '每公里单价',
        minKm: '最低里程',
        minCharge: '最低消费',
        baseFreight: '基础运费',
        chargeableBase: '计费基础运费',
        surchargeTotal: '附加费合计',
        totalAmount: '综合费用',
        calculationWarnings: '计算提示',
        chargeName: '费用名称',
        billingMode: '计费模式',
        chargeConfig: '单价配置',
        measure: '计费单位',
        calculationProcess: '计算过程',
        quantity: '数量',
        unitRate: '单价',
        amount: '金额',
        createdBy: '创建人',
        dateCreated: '创建时间',
        modifiedBy: '最后修改人',
        dateModified: '最后修改时间'
      },
      placeholders: {
        all: '全部',
        queryDate: '请选择查询日期',
        carrier: '请选择快递公司',
        office: '请选择所属公司',
        serviceType: '请选择服务类型',
        billingModel: '请选择计费模型',
        priceNo: '请输入运价号',
        cargoType: '请选择货物类型',
        warehouse: '请选择仓库',
        expectedVehicleType: '请输入车型'
      },
      sections: {
        origin: '发货地',
        destination: '目的地'
      },
      actions: {
        search: '查询',
        reset: '重置',
        detail: '详情',
        close: '关闭',
        associateConsignment: '关联委托单',
        cancelAssociation: '取消关联',
        confirmAssociation: '确认关联'
      },
      messages: {
        resultCount: '共 {count} 条快递运价',
        noData: '暂无快递运价结果',
        fetchFailed: '快递运价查询失败',
        detailFetchFailed: '快递运价详情加载失败',
        noDetail: '暂无运价详情',
        exportFilename: '快递运价查询'
      },
      sort: {
        default: '有效期由近到远',
        priceAsc: '币种内价格升序',
        priceDesc: '币种内价格降序',
        priceTip: '价格排序按币种分组比较；多币种和计算不完整的运价置后。'
      },
      labels: {
        recommended: '推荐',
        surchargeCount: '{count} 项附加费',
        noLimit: '不限',
        tier: '阶梯 {index}',
        tierCount: '{count} 个重量段',
        totalPerKm: '综合费用/公里',
        totalPerTrip: '综合费用/车次',
        totalAmount: '综合费用',
        expired: '已失效'
      },
      detail: {
        title: '运价详情',
        basicInfo: '基础信息',
        routeInfo: '路线信息',
        billingRule: '计费规则',
        billingDetail: '计费详情',
        billingFormula: '计费公式',
        calculation: '计算结果',
        surchargeDetail: '附加费明细',
        operationLog: '操作日志',
        feeCalculation: '费用计算',
        finalAmount: '综合费用'
      },
      formula: {
        firstAdditionalBase: '基础运费 = 首重价格 + 续重费用',
        unitPriceBase: '基础运费 = 计费数量 × 单价',
        weightTierBaseWithoutAdditional: '续重单价为空：基础运费 = 计费重量 × 命中重量段单价',
        weightTierBaseWithAdditional: '续重单价有值：基础运费 = 单价 +（计费重量 - 起始重量）× 续重单价',
        tripBase: '基础运费 = 整车一口价',
        kmBase: '基础运费 = 每公里单价',
        finalWithMinCharge: '综合费用 = MAX(基础运费, 最低消费) + 附加费合计',
        finalWithSurcharge: '综合费用 = 基础运费 + 附加费合计',
        surchargeFirstAdditionalConfig: '首重 {first} / 续重 {additional}',
        fixedSurchargeProcess: '固定费用 {amount}',
        firstAdditionalSurchargeProcess: '首重续重计算，数量 {quantity}，金额 {amount}',
        unitSurchargeProcess: '{unitRate} × {quantity}'
      },
      calculationWarnings: {
        CONTEXT_REQUIRED: '缺少查询上下文，已按默认条件计算。',
        WEIGHT_REQUIRED: '缺少计费重量，无法计算按重量相关费用。',
        SIZE_REQUIRED: '缺少尺寸信息，无法计算体积重。',
        PIECES_REQUIRED: '缺少件数，无法计算体积重或按件费用。',
        VOLUME_REQUIRED: '缺少总体积，无法计算按体积费用。',
        PRICE_DETAIL_REQUIRED: '缺少计费明细，无法计算基础运费。',
        WEIGHT_TIER_NOT_MATCHED: '未匹配到对应重量段。',
        SURCHARGE_MEASURE_REQUIRED: '附加费计费单位无法解析，无法判断是否按重量计费。',
        SURCHARGE_PERCENTAGE_INVALID: '燃油附加费百分比必须在 0-100 之间。',
        SURCHARGE_PERCENTAGE_NOT_ALLOWED: '非燃油附加费不能使用百分比计费。'
      },
      association: {
        title: '关联委托单',
        searchPlaceholder: '请输入委托单号',
        feePreviewTitle: '费用确认',
        feeDetailTitle: '带入费用明细',
        totalLabel: '综合费用',
        confirmImportTip: '确认后会将以下费用带入委托单应付费用。',
        alreadyAssociated: '已关联',
        currentAssociated: '已关联当前运价',
        canAssociate: '可关联',
        existingPayableFees: '当前委托单已有应付费用，本次只建立关联关系，不写入费用。',
        cancelConfirmTitle: '取消关联',
        cancelConfirmContent: '取消关联不会删除已写入委托单的费用，确认继续吗？',
        actions: {
          associate: '关联'
        },
        units: {
          pieces: '件',
          weight: 'kg'
        },
        columns: {
          consignmentNo: '委托单号',
          businessType: '业务类型',
          route: '路线',
          origin: '发货地',
          destination: '收货地',
          cargoInfo: '货物信息',
          orderStatus: '委托单状态',
          supplierName: '供应商',
          associationStatus: '关联状态',
          associatedPriceNo: '已关联运价号',
          feeName: '费用名称',
          feeSource: '费用来源',
          settlementObject: '结算对象',
          quantity: '数量',
          unitPrice: '单价',
          amount: '金额',
          remarks: '备注',
          actions: '操作'
        },
        feeSource: {
          BASE_FREIGHT: '基础运费',
          MANUAL: '手工附加费',
          SYSTEM: '系统附加费'
        },
        messages: {
          fetchFailed: '委托单查询失败',
          previewFailed: '费用预览失败',
          confirmFailed: '关联委托单失败',
          cancelFailed: '取消关联失败',
          keywordRequired: '请输入委托单号后再查询',
          noConsignmentFound: '未找到匹配的委托单',
          searchPrompt: '请输入委托单号搜索',
          associationSuccess: '关联成功，已写入 {count} 条应付费用',
          associationSuccessSkipped: '关联成功，因委托单已有应付费用，已跳过费用写入',
          cancelSuccess: '取消关联成功'
        }
      },
      columns: {
        priceNo: '运价号',
        carrier: '快递公司',
        serviceType: '服务类型',
        loadMode: '装载模式',
        cargoType: '货物类型',
        origin: '发货地',
        destination: '目的地',
        billingModel: '计费模型',
        billingDetail: '计费详情',
        surcharge: '附加费',
        totalAmount: '综合费用',
        validity: '有效期',
        actions: '操作'
      },
      enums: {
        surchargeBillingMode: {
          FIRST_ADDITIONAL: '首重+续重',
          UNIT_PRICE: '单价计费',
          FIXED: '固定费用'
        }
      }
    }
  }
}
